import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export type AccountViewDispatchOptions = {
  __typename?: 'AccountViewDispatchOptions';
  meta: DispatchResultMeta;
};

export type AccountViewDispatchResultModel = {
  __typename?: 'AccountViewDispatchResultModel';
  accountViewOptions: AccountViewDispatchOptions;
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export enum BarcodeEnum {
  Ean13 = 'EAN13'
}

export type Brand = {
  __typename?: 'Brand';
  id: Scalars['Float'];
  label: Scalars['String'];
};

export type CancelOrderInput = {
  orderId: Scalars['ID'];
};

export type CartViewDispatchOptions = {
  __typename?: 'CartViewDispatchOptions';
  meta: DispatchResultMeta;
  trackEmailId?: Maybe<Scalars['Float']>;
};

export type CartViewDispatchResultModel = {
  __typename?: 'CartViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  cartViewOptions: CartViewDispatchOptions;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type CatalogBaseQuery = {
  __typename?: 'CatalogBaseQuery';
  in?: Maybe<Array<Maybe<CatalogBaseQueryData>>>;
  notIn?: Maybe<Array<Maybe<CatalogBaseQueryData>>>;
};

export type CatalogBaseQueryData = {
  __typename?: 'CatalogBaseQueryData';
  type: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type CatalogFacet = {
  __typename?: 'CatalogFacet';
  brandIds?: Maybe<Array<Scalars['ID']>>;
  categoryIds?: Maybe<Array<Scalars['ID']>>;
  colorGroupIds?: Maybe<Array<Scalars['ID']>>;
  manClothingSizeGroupIds?: Maybe<Array<Scalars['ID']>>;
  manShoesSizeGroupIds?: Maybe<Array<Scalars['ID']>>;
  sizeIds?: Maybe<Array<Scalars['ID']>>;
  womanClothingSizeGroupIds?: Maybe<Array<Scalars['ID']>>;
  womanShoesSizeGroupIds?: Maybe<Array<Scalars['ID']>>;
};

export enum CatalogFacetType {
  Checkbox = 'checkbox',
  Link = 'link',
  SelectCheckbox = 'select_checkbox'
}

export type CatalogGetGuiProductColorVariantMediaInput = {
  featured?: InputMaybe<Scalars['Boolean']>;
  transformations: Array<Scalars['String']>;
};

export type CatalogIdModel = {
  __typename?: 'CatalogIdModel';
  cSel: Scalars['String'];
  productId: Scalars['ID'];
};

export type CatalogProductData = {
  cSel?: InputMaybe<Scalars['String']>;
  productId: Scalars['ID'];
};

export type CatalogProductView = {
  __typename?: 'CatalogProductView';
  activeFacets?: Maybe<Array<Maybe<CatalogProductViewActiveFacet>>>;
  facets?: Maybe<Array<Maybe<ProductViewFacet>>>;
  pagination: ProductViewPagination;
  productCatalogViews?: Maybe<Array<Maybe<ProductCatalogViewV2>>>;
  sorts: Array<CatalogProductViewSort>;
};

export type CatalogProductViewActiveFacet = {
  __typename?: 'CatalogProductViewActiveFacet';
  id: Scalars['ID'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type CatalogProductViewSort = {
  __typename?: 'CatalogProductViewSort';
  field: CatalogSortV2;
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
};

export type CatalogResponseFacet = {
  __typename?: 'CatalogResponseFacet';
  columns: Scalars['Float'];
  insight?: Maybe<CatalogResponseFacetInsight>;
  key: Scalars['String'];
  label: Scalars['String'];
  type: CatalogFacetType;
  values: Array<CatalogResponseFacetValue>;
};

export type CatalogResponseFacetInsight = {
  __typename?: 'CatalogResponseFacetInsight';
  count: Scalars['Float'];
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CatalogResponseFacetValue = {
  __typename?: 'CatalogResponseFacetValue';
  available: Scalars['Boolean'];
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  selected: Scalars['Boolean'];
  values?: Maybe<Array<Maybe<CatalogResponseFacetValue>>>;
};

export type CatalogResponsePagination = {
  __typename?: 'CatalogResponsePagination';
  currentPage: Scalars['Float'];
  cursor?: Maybe<CatalogResponsePaginationCursorModel>;
  lastPage: Scalars['Float'];
};

export type CatalogResponsePaginationCursorModel = {
  __typename?: 'CatalogResponsePaginationCursorModel';
  current?: Maybe<Scalars['String']>;
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  scrollTime: Scalars['String'];
};

export type CatalogResponseSortOptions = {
  __typename?: 'CatalogResponseSortOptions';
  active: Scalars['Boolean'];
  key: CatalogSortKey;
  label: Scalars['String'];
};

export enum CatalogSortKey {
  Discount = 'discount',
  Latest = 'latest',
  PriceAsc = 'priceAsc',
  PriceDesc = 'priceDesc',
  Relevance = 'relevance'
}

export enum CatalogSortV2 {
  Discount = 'DISCOUNT',
  Latest = 'LATEST',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  Relevance = 'RELEVANCE',
  Unrecognized = 'UNRECOGNIZED'
}

export type CatalogV2Facet = {
  __typename?: 'CatalogV2Facet';
  id: Scalars['ID'];
  values?: Maybe<Array<Scalars['String']>>;
};

export type CatalogV2ViewOptions = {
  __typename?: 'CatalogV2ViewOptions';
  disableSort?: Maybe<Scalars['Boolean']>;
  facets?: Maybe<Array<CatalogV2Facet>>;
  query?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
};

export type CatalogViewDispatchOptions = {
  __typename?: 'CatalogViewDispatchOptions';
  catalog?: Maybe<CatalogViewOptions>;
  catalogV2?: Maybe<CatalogV2ViewOptions>;
  meta?: Maybe<DispatchResultMeta>;
};

export type CatalogViewDispatchResult = {
  __typename?: 'CatalogViewDispatchResult';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  catalogViewOptions: CatalogViewDispatchOptions;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type CatalogViewOptions = {
  __typename?: 'CatalogViewOptions';
  baseQuery?: Maybe<Array<CatalogBaseQuery>>;
  facets?: Maybe<CatalogFacet>;
  orderBy?: Maybe<Scalars['String']>;
  queryV2?: Maybe<Scalars['String']>;
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['Float'];
  label: Scalars['String'];
  parentId: Scalars['Float'];
};

export type ConnectionRequestInput = {
  excludeProperties?: InputMaybe<Array<Scalars['String']>>;
  pagination?: InputMaybe<QueryBuilderPaginationModel>;
  qb?: InputMaybe<Array<QueryBuilderDataModel>>;
  withCache?: InputMaybe<Scalars['Boolean']>;
};

export enum ConsentStrategy {
  Gdpr = 'GDPR',
  None = 'NONE'
}

export type Contact = {
  __typename?: 'Contact';
  address: Scalars['String'];
  bic?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  couriers?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['String']>;
  deliveryNoteShippingInfo?: Maybe<Array<DeliveryNoteShippingInfo>>;
  facilityCode?: Maybe<Scalars['String']>;
  facilityPoint?: Maybe<Scalars['Float']>;
  fiscalCode?: Maybe<Scalars['String']>;
  freeShipments?: Maybe<Scalars['Boolean']>;
  iban: Scalars['String'];
  id: Scalars['ID'];
  img?: Maybe<Scalars['String']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  isFacility?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  region: Scalars['String'];
  shippingAddress?: Maybe<Array<ShippingAddress>>;
  shippingDestination?: Maybe<Scalars['Boolean']>;
  taxCode: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type ContactConnectionResponse = {
  __typename?: 'ContactConnectionResponse';
  aggregate?: Maybe<ContactModelQueryBuilderAggregateModel>;
  edges?: Maybe<Array<ContactModelEdge>>;
  pageInfo?: Maybe<ContactModelQueryBuilderPageInfoModel>;
};

export type ContactModelEdge = {
  __typename?: 'ContactModelEdge';
  cursor: Scalars['String'];
  node: Contact;
};

export type ContactModelQueryBuilderAggregateModel = {
  __typename?: 'ContactModelQueryBuilderAggregateModel';
  count: Scalars['Int'];
};

export type ContactModelQueryBuilderPageInfoModel = {
  __typename?: 'ContactModelQueryBuilderPageInfoModel';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type ContactsViewDispatchOptions = {
  __typename?: 'ContactsViewDispatchOptions';
  meta: DispatchResultMeta;
};

export type ContactsViewDispatchResultModel = {
  __typename?: 'ContactsViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  contactsViewOptions: ContactsViewDispatchOptions;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type CopyDiscountsFromCheckboxInput = {
  copyDiscountFrom: Scalars['String'];
  copyDiscountTo: Scalars['String'];
};

export type CopyDiscountsFromCheckboxResponse = {
  __typename?: 'CopyDiscountsFromCheckboxResponse';
  modifiedCount: Scalars['Float'];
  success: Scalars['Boolean'];
};

export type Country = {
  __typename?: 'Country';
  code?: Maybe<Scalars['Float']>;
  consentStrategy: ConsentStrategy;
  cplDhl?: Maybe<Scalars['Float']>;
  currencyPaid: Scalars['String'];
  currencyView: Scalars['String'];
  detailsConnection?: Maybe<Array<CountryDetailConnection>>;
  dhl?: Maybe<Scalars['Float']>;
  dutyAdd: Scalars['Float'];
  hasDdp: Scalars['Boolean'];
  hasTax?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  iso2?: Maybe<Scalars['String']>;
  iso3?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  regionCode?: Maybe<Scalars['String']>;
  salesGroup?: Maybe<Scalars['String']>;
  sda?: Maybe<Scalars['Float']>;
  shipCode?: Maybe<Scalars['String']>;
  ups: Scalars['Float'];
  vat: Scalars['Float'];
};

export type CountryDetailConnection = {
  __typename?: 'CountryDetailConnection';
  aggregate?: Maybe<CountryDetailModelQueryBuilderAggregateModel>;
  edges?: Maybe<Array<CountryDetailModelEdge>>;
  pageInfo?: Maybe<CountryDetailModelQueryBuilderPageInfoModel>;
};

export type CountryDetailModel = {
  __typename?: 'CountryDetailModel';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CountryDetailModelEdge = {
  __typename?: 'CountryDetailModelEdge';
  cursor: Scalars['String'];
  node: CountryDetailModel;
};

export type CountryDetailModelQueryBuilderAggregateModel = {
  __typename?: 'CountryDetailModelQueryBuilderAggregateModel';
  count: Scalars['Int'];
};

export type CountryDetailModelQueryBuilderPageInfoModel = {
  __typename?: 'CountryDetailModelQueryBuilderPageInfoModel';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type CreatePwaOrderInput = {
  customerShippingAddressId: Scalars['Float'];
  lines: Array<CreatePwaOrderLineInput>;
  locale: Scalars['String'];
  reference: Scalars['String'];
};

export type CreatePwaOrderLineInput = {
  compareAtTaxIncluded?: InputMaybe<Scalars['Float']>;
  productComponentId?: InputMaybe<Scalars['Float']>;
  quantity: Scalars['Float'];
  taxIncluded: Scalars['Float'];
};

export type CreateRmaComponentInput = {
  id: Scalars['Float'];
  price: Scalars['Float'];
  productComponentId: Scalars['Float'];
  quantity: Scalars['Float'];
};

export type CreateRmaInput = {
  components: Array<CreateRmaComponentInput>;
  orderId: Scalars['Float'];
  shippingAddress: RmaShippingAddressInput;
  tracking?: InputMaybe<RmaTrackingInput>;
};

export type Customer = {
  __typename?: 'Customer';
  billingAddress?: Maybe<Scalars['String']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Country>;
  billingProvince?: Maybe<Scalars['String']>;
  billingZip?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  companyName?: Maybe<Scalars['String']>;
  contexts?: Maybe<Array<CustomerContext>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  fiscalCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isB2B: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  isGuest: Scalars['Boolean'];
  isVip: Scalars['Boolean'];
  isWholesale: Scalars['Boolean'];
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ordersView?: Maybe<Array<OrderView>>;
  ordersViewPage?: Maybe<OrderViewPage>;
  pec?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sdi?: Maybe<Scalars['String']>;
  shippingAddresses?: Maybe<Array<CustomerShippingAddressExtended>>;
  skipRiskified?: Maybe<Scalars['Boolean']>;
  surname?: Maybe<Scalars['String']>;
  vIn?: Maybe<Scalars['String']>;
  vLs?: Maybe<Scalars['String']>;
  vatCode?: Maybe<Scalars['Float']>;
  vatNum?: Maybe<Scalars['String']>;
  viewOrder?: Maybe<OrderView>;
};


export type CustomerBillingCountryArgs = {
  data?: InputMaybe<GetCustomerBillingCountryInput>;
};


export type CustomerOrdersViewArgs = {
  data: GetCustomerOrderViewInput;
};


export type CustomerOrdersViewPageArgs = {
  data: GetCustomerOrderViewInput;
};


export type CustomerShippingAddressesArgs = {
  data: GetCustomerShippingAddressesInput;
};


export type CustomerViewOrderArgs = {
  data: GetCustomerViewOrderInput;
};

export type CustomerContext = {
  __typename?: 'CustomerContext';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  handle: Scalars['String'];
  id: Scalars['ID'];
  privileges?: Maybe<Array<CustomerContextPrivilege>>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomerContextPrivilege = {
  __typename?: 'CustomerContextPrivilege';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  handle: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomerOrdersViewPaginationInput = {
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type CustomerShippingAddress = {
  __typename?: 'CustomerShippingAddress';
  address: Array<Scalars['String']>;
  at?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  isPreferred?: Maybe<Scalars['Boolean']>;
  mobile?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  verified: Scalars['Boolean'];
  zipCode: Scalars['String'];
};

export type CustomerShippingAddressExtended = {
  __typename?: 'CustomerShippingAddressExtended';
  address: Array<Scalars['String']>;
  at?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  isPreferred?: Maybe<Scalars['Boolean']>;
  mobile?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  verified: Scalars['Boolean'];
  zipCode: Scalars['String'];
};

export type DeliveryNoteShippingInfo = {
  __typename?: 'DeliveryNoteShippingInfo';
  courier?: Maybe<Scalars['String']>;
  destination: Scalars['String'];
  enabled: Scalars['Boolean'];
};

export type DesignersViewDispatchOptions = {
  __typename?: 'DesignersViewDispatchOptions';
  meta: DispatchResultMeta;
};

export type DesignersViewDispatchResultModel = {
  __typename?: 'DesignersViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  designersViewOptions: DesignersViewDispatchOptions;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type DiscountRange = {
  __typename?: 'DiscountRange';
  allowedDiscount?: Maybe<Array<Maybe<Scalars['Float']>>>;
  createdAt: Scalars['String'];
  dateChoiceEnd: Scalars['String'];
  dateChoiceStart: Scalars['String'];
  dateStart: Scalars['String'];
  deletedAt: Scalars['String'];
  description: Scalars['String'];
  discount: Scalars['Float'];
  discountRangeType: Scalars['String'];
  id: Scalars['ID'];
  maxDiscount: Scalars['Float'];
  updatedAt: Scalars['String'];
};

export enum DiscountRangeType {
  Unrecognized = 'UNRECOGNIZED',
  AlwaysOn = 'always_on',
  Boutique = 'boutique',
  InSeason = 'in_season',
  Lifestyle = 'lifestyle',
  Outlet = 'outlet'
}

export type DiscountResponseModel = {
  __typename?: 'DiscountResponseModel';
  discountRangeId: Scalars['String'];
  discountValue: Scalars['Float'];
  permanent: Scalars['Boolean'];
};

export type DiscountSuggested = {
  __typename?: 'DiscountSuggested';
  brandId: Scalars['Float'];
  discount: Scalars['Float'];
  discountRangeId: Scalars['String'];
  id: Scalars['String'];
  mainCategoryId: Scalars['Float'];
};

export type DispatchResultAlternativeModel = {
  __typename?: 'DispatchResultAlternativeModel';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export type DispatchResultEntityIdentifier = {
  __typename?: 'DispatchResultEntityIdentifier';
  entity: UrlEntity;
};

export type DispatchResultIdentifier = DispatchResultEntityIdentifier | DispatchResultUriGroupIdentifier;

export type DispatchResultMeta = {
  __typename?: 'DispatchResultMeta';
  description?: Maybe<Scalars['String']>;
  fullText?: Maybe<Scalars['String']>;
  isFullTextSEO?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type DispatchResultRedirectInfoModel = {
  __typename?: 'DispatchResultRedirectInfoModel';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export type DispatchResultUriGroupIdentifier = {
  __typename?: 'DispatchResultUriGroupIdentifier';
  uriGroupId: Scalars['String'];
};

export type DispatchUrl = AccountViewDispatchResultModel | CartViewDispatchResultModel | CatalogViewDispatchResult | ContactsViewDispatchResultModel | DesignersViewDispatchResultModel | FestiveSeasonViewDispatchResultModel | HomeViewDispatchResultModel | InvestorSiteViewDispatchResultModel | LandingBeautySeekersViewDispatchResultModel | LandingGiftGuide24ViewDispatchResultModel | LandingGiftGuideViewDispatchResultModel | LandingHomeDecorViewDispatchResultModel | LandingSpecial0ViewDispatchResultModel | LandingSpecial1ViewDispatchResultModel | LandingVestiaireCollectiveViewDispatchResultModel | LifestyleViewDispatchResult | NotificationViewDispatchResultModel | OrderViewDispatchResult | PageDispatchResultModel | PassResetViewDispatchResultModel | ProductViewDispatchResult | UpdatePreferenceViewDispatchResultModel | WishlistShareViewDispatchResultModel | WishlistViewDispatchResultModel;

export type DispatchUrlInput = {
  apiVersion?: InputMaybe<Scalars['Float']>;
  categoryId?: InputMaybe<Scalars['Float']>;
  locale?: InputMaybe<Scalars['String']>;
  referral?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type ExchangePriceWithDiscount = {
  __typename?: 'ExchangePriceWithDiscount';
  values: ProductComponentPriceDataValuesVal;
  view: ProductComponentPriceDataValuesVal;
};

export type FacetInput = {
  id: Scalars['String'];
  values: Array<Scalars['String']>;
};

export enum FacetPresentation {
  Checkbox = 'CHECKBOX',
  Link = 'LINK',
  Range = 'RANGE',
  Unrecognized = 'UNRECOGNIZED'
}

export type FacetValue = {
  __typename?: 'FacetValue';
  count?: Maybe<Scalars['Float']>;
  enabled: Scalars['Boolean'];
  href?: Maybe<Scalars['String']>;
  isSelected: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type FestiveSeasonViewDispatchOptions = {
  __typename?: 'FestiveSeasonViewDispatchOptions';
  gender: Scalars['String'];
  meta: DispatchResultMeta;
};

export type FestiveSeasonViewDispatchResultModel = {
  __typename?: 'FestiveSeasonViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  festiveSeasonViewOptions: FestiveSeasonViewDispatchOptions;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type Filter = {
  __typename?: 'Filter';
  brands?: Maybe<Array<Maybe<Brand>>>;
  categories?: Maybe<Array<Maybe<Category>>>;
  discounts?: Maybe<Array<Maybe<Scalars['Float']>>>;
  seasons?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GetCatalogProductViewInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  currentUrl?: InputMaybe<ProductViewCurrentUrlInput>;
  facets?: InputMaybe<Array<FacetInput>>;
  locale: Scalars['String'];
  page?: InputMaybe<Scalars['Float']>;
  pageSize: Scalars['Int'];
  query: Scalars['String'];
  sort: Scalars['String'];
};

export type GetCustomerBillingCountryInput = {
  locale?: InputMaybe<Scalars['String']>;
};

export type GetCustomerOrderViewInput = {
  locale: Scalars['String'];
  pagination?: InputMaybe<CustomerOrdersViewPaginationInput>;
  rejectStatus?: InputMaybe<Array<Scalars['String']>>;
};

export type GetCustomerShippingAddressesInput = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type GetCustomerViewOrderInput = {
  locale: Scalars['String'];
  orderId: Scalars['Float'];
};

export type GetDiscountRangesRequestInput = {
  discountRangeType: DiscountRangeType;
  isEditable: Scalars['Boolean'];
};

export type GetEligibleProductPermanentInput = {
  page: Scalars['Float'];
  partnerId?: InputMaybe<Scalars['Float']>;
};

export type GetOrderRequestInput = {
  id: Scalars['ID'];
};

export type GetPartnerByIdRequestInput = {
  id: Scalars['ID'];
};

export type GetProductsDiscountByDiscountRangeRequestInput = {
  discountRangeType: DiscountRangeType;
  page: Scalars['Float'];
  queryFilter: QueryFilterInput;
};

export type GetProductsToTransferInput = {
  categoryId?: InputMaybe<Scalars['Int']>;
  currentSeason?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  linesId?: InputMaybe<Scalars['Int']>;
  newSeason?: InputMaybe<Scalars['String']>;
  partnerIds?: InputMaybe<Array<Scalars['Int']>>;
  skip: Scalars['Int'];
};

export type GetProductsToTransferResponse = {
  __typename?: 'GetProductsToTransferResponse';
  aggregations: ProductsToTransferAggregations;
  pagination: ProductsToTransferPagination;
  products?: Maybe<Array<Maybe<ProductToTransfer>>>;
};

export type GuiProductColorVariantMedia = {
  __typename?: 'GuiProductColorVariantMedia';
  fileName: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  transformationName: Scalars['String'];
  url: Scalars['String'];
};

export type HomeViewDispatchOptions = {
  __typename?: 'HomeViewDispatchOptions';
  meta: DispatchResultMeta;
};

export type HomeViewDispatchResultModel = {
  __typename?: 'HomeViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  homeViewOptions: HomeViewDispatchOptions;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export enum ImportEnum {
  Ftp = 'FTP',
  Manual = 'MANUAL',
  Table = 'TABLE'
}

export type InvestorSiteViewDispatchOptions = {
  __typename?: 'InvestorSiteViewDispatchOptions';
  meta: DispatchResultMeta;
};

export type InvestorSiteViewDispatchResultModel = {
  __typename?: 'InvestorSiteViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  investorSiteViewOptions: InvestorSiteViewDispatchOptions;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type ItemReturnReason = {
  __typename?: 'ItemReturnReason';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type LandingBeautySeekersViewDispatchOptions = {
  __typename?: 'LandingBeautySeekersViewDispatchOptions';
  meta: DispatchResultMeta;
};

export type LandingBeautySeekersViewDispatchResultModel = {
  __typename?: 'LandingBeautySeekersViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  landingBeautySeekersViewOptions: LandingBeautySeekersViewDispatchOptions;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type LandingBoxModel = {
  __typename?: 'LandingBoxModel';
  catalogIds?: Maybe<Array<CatalogIdModel>>;
};

export type LandingGiftGuide24ViewDispatchOptions = {
  __typename?: 'LandingGiftGuide24ViewDispatchOptions';
  boxes?: Maybe<Array<LandingBoxModel>>;
  gender: Scalars['String'];
  meta: DispatchResultMeta;
};

export type LandingGiftGuide24ViewDispatchResultModel = {
  __typename?: 'LandingGiftGuide24ViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  landingGiftGuide24ViewOptions: LandingGiftGuide24ViewDispatchOptions;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type LandingGiftGuideViewDispatchOptions = {
  __typename?: 'LandingGiftGuideViewDispatchOptions';
  meta: DispatchResultMeta;
};

export type LandingGiftGuideViewDispatchResultModel = {
  __typename?: 'LandingGiftGuideViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  landingGiftGuideViewOptions: LandingGiftGuideViewDispatchOptions;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type LandingHomeDecorViewDispatchOptions = {
  __typename?: 'LandingHomeDecorViewDispatchOptions';
  meta: DispatchResultMeta;
};

export type LandingHomeDecorViewDispatchResultModel = {
  __typename?: 'LandingHomeDecorViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  landingHomeDecorViewOptions: LandingHomeDecorViewDispatchOptions;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type LandingSpecial0ViewDispatchOptions = {
  __typename?: 'LandingSpecial0ViewDispatchOptions';
  catalog?: Maybe<CatalogViewOptions>;
  catalogV2?: Maybe<CatalogV2ViewOptions>;
  meta: DispatchResultMeta;
};

export type LandingSpecial0ViewDispatchResultModel = {
  __typename?: 'LandingSpecial0ViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  landingSpecial0ViewOptions: LandingSpecial0ViewDispatchOptions;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type LandingSpecial1ViewDispatchOptions = {
  __typename?: 'LandingSpecial1ViewDispatchOptions';
  catalog?: Maybe<CatalogViewOptions>;
  catalogV2?: Maybe<CatalogV2ViewOptions>;
  meta: DispatchResultMeta;
};

export type LandingSpecial1ViewDispatchResultModel = {
  __typename?: 'LandingSpecial1ViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  landingSpecial1ViewOptions: LandingSpecial1ViewDispatchOptions;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type LandingVestiaireCollectiveViewDispatchOptions = {
  __typename?: 'LandingVestiaireCollectiveViewDispatchOptions';
  meta: DispatchResultMeta;
};

export type LandingVestiaireCollectiveViewDispatchResultModel = {
  __typename?: 'LandingVestiaireCollectiveViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  landingVestiaireCollectiveViewOptions: LandingVestiaireCollectiveViewDispatchOptions;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type LanguageModel = {
  __typename?: 'LanguageModel';
  baseUrl?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  iso2?: Maybe<Scalars['String']>;
  iso3?: Maybe<Scalars['String']>;
  localeCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type LifestyleViewDispatchOptions = {
  __typename?: 'LifestyleViewDispatchOptions';
  meta: DispatchResultMeta;
};

export type LifestyleViewDispatchResult = {
  __typename?: 'LifestyleViewDispatchResult';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  lifestyleViewOptions?: Maybe<LifestyleViewDispatchOptions>;
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type MoneyValueInt = {
  __typename?: 'MoneyValueInt';
  tax: Scalars['Float'];
  taxIncluded: Scalars['Float'];
  taxable: Scalars['Float'];
};

export type MoneyValueString = {
  __typename?: 'MoneyValueString';
  tax: Scalars['String'];
  taxIncluded: Scalars['String'];
  taxable: Scalars['String'];
};

export type MoneyValueTransformer = {
  __typename?: 'MoneyValueTransformer';
  currencyCode: Scalars['String'];
  values: MoneyValueInt;
  view: MoneyValueString;
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelOrder: Scalars['String'];
  copyDiscountsFromCheckbox: CopyDiscountsFromCheckboxResponse;
  createPwaOrder: Order;
  createRma: Rma;
  setPermanent: SetPermanentResponse;
  syncProductsTransfer?: Maybe<SyncProductsTransferResponse>;
  updateProductDiscount: Scalars['Boolean'];
  updateProductsDiscountByFilter: Scalars['Boolean'];
  updateProductsDiscountMultiple: Scalars['Boolean'];
};


export type MutationCancelOrderArgs = {
  data: CancelOrderInput;
};


export type MutationCopyDiscountsFromCheckboxArgs = {
  data: CopyDiscountsFromCheckboxInput;
};


export type MutationCreatePwaOrderArgs = {
  data: CreatePwaOrderInput;
};


export type MutationCreateRmaArgs = {
  data: CreateRmaInput;
};


export type MutationSetPermanentArgs = {
  data: SetProductPermanentInput;
};


export type MutationSyncProductsTransferArgs = {
  data: SyncProductsTransferInput;
};


export type MutationUpdateProductDiscountArgs = {
  data: UpdateProductDiscountRequestInput;
};


export type MutationUpdateProductsDiscountByFilterArgs = {
  data: UpdateProductsDiscountByFilterRequestInput;
};


export type MutationUpdateProductsDiscountMultipleArgs = {
  data: UpdateProductsDiscountMultipleRequestInput;
};

export type NotificationViewDispatchOptions = {
  __typename?: 'NotificationViewDispatchOptions';
  meta: DispatchResultMeta;
};

export type NotificationViewDispatchResultModel = {
  __typename?: 'NotificationViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  notificationViewOptions: NotificationViewDispatchOptions;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type Order = {
  __typename?: 'Order';
  bankTransferNotification: Scalars['Float'];
  components: Array<OrderComponent>;
  currencyCode: Scalars['String'];
  currencyExchange: Scalars['Float'];
  customer: Customer;
  customerCareStatus: OrderStatus;
  customerSatisfaction: Scalars['Float'];
  customerShipmentId: Scalars['Float'];
  date: Scalars['String'];
  discount: Scalars['String'];
  dutyAdd: Scalars['Float'];
  enabled: Scalars['Boolean'];
  facilityId: Scalars['ID'];
  hash: Scalars['String'];
  id: Scalars['ID'];
  ipAddress: Scalars['String'];
  isGift: Scalars['Boolean'];
  iso2?: Maybe<Scalars['String']>;
  items: Array<OrderComponent>;
  language?: Maybe<LanguageModel>;
  locale: Scalars['String'];
  paymentId: Scalars['ID'];
  referenceNumber: Scalars['String'];
  semaphore: Scalars['String'];
  shipmentAddress: CustomerShippingAddress;
  shipmentNotification: Scalars['Float'];
  shippingCost: Scalars['Float'];
  source: Scalars['String'];
  status: Scalars['String'];
  subTotal: Scalars['Float'];
  tax: Scalars['Float'];
  toInvoice: Scalars['Boolean'];
  total: Scalars['Float'];
  vector: Scalars['String'];
};

export type OrderComponent = {
  __typename?: 'OrderComponent';
  enabled: Scalars['Boolean'];
  extraDiscount: Scalars['Float'];
  id: Scalars['ID'];
  origin: Scalars['Float'];
  originalTaxable: Scalars['Float'];
  price: Scalars['Float'];
  pricePurchase: Scalars['Float'];
  pricePurchaseDiscount: Scalars['Float'];
  priceSupplier: Scalars['Float'];
  printed: Scalars['Float'];
  quantity: Scalars['Float'];
  season: Scalars['String'];
  semaphore: Scalars['String'];
  sent: Scalars['Boolean'];
  slot: Scalars['Float'];
  supplierId: Scalars['ID'];
  tax: Scalars['Float'];
  taxable: Scalars['Float'];
  taxes: Array<OrderComponentTax>;
};

export type OrderComponentTax = {
  __typename?: 'OrderComponentTax';
  currencyCode: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity: Scalars['Float'];
  type: Scalars['String'];
  value: Scalars['Float'];
};

export type OrderInfo = {
  __typename?: 'OrderInfo';
  label: Scalars['String'];
  position: Scalars['Float'];
  type: Scalars['String'];
  valueSet: MoneyValueTransformer;
};

export type OrderStatus = {
  __typename?: 'OrderStatus';
  createdAt: Scalars['DateTime'];
  date: Scalars['DateTime'];
  note: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type OrderView = {
  __typename?: 'OrderView';
  billingAddress: OrderViewCustomerBillingAddress;
  components?: Maybe<Array<OrderViewComponent>>;
  date: Scalars['DateTime'];
  fullStatus?: Maybe<Array<OrderViewFullStatusStep>>;
  id: Scalars['ID'];
  isGift: Scalars['Boolean'];
  isGuest: Scalars['Boolean'];
  items?: Maybe<Array<OrderViewComponent>>;
  localDate: Scalars['String'];
  locale: Scalars['String'];
  orderInfo?: Maybe<Array<OrderInfo>>;
  paymentMethod?: Maybe<PaymentMethod>;
  referenceNumber: Scalars['String'];
  returnInfo?: Maybe<ReturnInfo>;
  returnPolicy?: Maybe<ReturnPolicy>;
  rma?: Maybe<Array<RmaView>>;
  shipment?: Maybe<OrderViewShipment>;
  shipmentMethod?: Maybe<ShipmentMethod>;
  shippingAddress: OrderViewCustomerShippingAddress;
  shippingCost: Scalars['String'];
  status: Scalars['String'];
  storeCredit: OrderViewStoreCredit;
  subTotal: Scalars['String'];
  tax: Scalars['String'];
  total: Scalars['String'];
};

export type OrderViewComponent = {
  __typename?: 'OrderViewComponent';
  id: Scalars['ID'];
  locale: Scalars['String'];
  price: Scalars['String'];
  priceWithTax: Scalars['String'];
  product: ProductComponentView;
  quantity: Scalars['Float'];
  returnable: Scalars['Boolean'];
  tax: Scalars['String'];
  webTax: Scalars['String'];
};

export type OrderViewCustomerBillingAddress = {
  __typename?: 'OrderViewCustomerBillingAddress';
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  maskedName: Scalars['String'];
  maskedSurname: Scalars['String'];
  name: Scalars['String'];
  surname: Scalars['String'];
  zipCode: Scalars['String'];
};

export type OrderViewCustomerShippingAddress = {
  __typename?: 'OrderViewCustomerShippingAddress';
  address: Array<Scalars['String']>;
  at?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryId: Scalars['Float'];
  maskedName: Scalars['String'];
  maskedSurname: Scalars['String'];
  mobile: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  zipCode: Scalars['String'];
};

export type OrderViewDispatchOptions = {
  __typename?: 'OrderViewDispatchOptions';
  meta: DispatchResultMeta;
  orderId?: Maybe<Scalars['Float']>;
};

export type OrderViewDispatchResult = {
  __typename?: 'OrderViewDispatchResult';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  orderViewOptions?: Maybe<OrderViewDispatchOptions>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type OrderViewFullStatusStep = {
  __typename?: 'OrderViewFullStatusStep';
  active: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
};

export type OrderViewPage = {
  __typename?: 'OrderViewPage';
  ordersView?: Maybe<Array<OrderView>>;
  total: Scalars['Int'];
};

export type OrderViewShipment = {
  __typename?: 'OrderViewShipment';
  courierName: Scalars['String'];
  trackingNumber: Scalars['String'];
};

export type OrderViewStoreCredit = {
  __typename?: 'OrderViewStoreCredit';
  amount: Scalars['String'];
};

export type PageDispatchOptions = {
  __typename?: 'PageDispatchOptions';
  catalog?: Maybe<CatalogViewOptions>;
  catalogV2?: Maybe<CatalogV2ViewOptions>;
  meta: DispatchResultMeta;
};

export type PageDispatchResultModel = {
  __typename?: 'PageDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  pageViewOptions: PageDispatchOptions;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
};

export type Partner = {
  __typename?: 'Partner';
  barcodeType?: Maybe<BarcodeEnum>;
  contact?: Maybe<Contact>;
  controller?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  detail?: Maybe<PartnerDetail>;
  disabled: Scalars['Boolean'];
  discA: Scalars['Float'];
  discB: Scalars['Float'];
  discC: Scalars['Float'];
  discS: Scalars['Float'];
  emailNotify: Scalars['String'];
  enablePrinter: Scalars['Boolean'];
  facilityId?: Maybe<Scalars['String']>;
  formatId: Scalars['Float'];
  hasWarehouse: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  ordersFee?: Maybe<Scalars['Float']>;
  partnerCategoryId?: Maybe<Scalars['Float']>;
  personId?: Maybe<Scalars['String']>;
  pos: Scalars['Float'];
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  usePos: Scalars['Boolean'];
  vRuleSp: Scalars['Boolean'];
};

export type PartnerConnectionResponse = {
  __typename?: 'PartnerConnectionResponse';
  aggregate?: Maybe<PartnerModelQueryBuilderAggregateModel>;
  edges?: Maybe<Array<PartnerModelEdge>>;
  pageInfo?: Maybe<PartnerModelQueryBuilderPageInfoModel>;
};

export type PartnerDetail = {
  __typename?: 'PartnerDetail';
  atelierBoutique: Scalars['String'];
  atelierPsw: Scalars['String'];
  atelierUser: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  directUrl: Scalars['String'];
  emailIt: Scalars['String'];
  errorAlert?: Maybe<Scalars['String']>;
  ftpHost: Scalars['String'];
  ftpPsw: Scalars['String'];
  ftpUser: Scalars['String'];
  id: Scalars['ID'];
  importImageWith?: Maybe<Scalars['String']>;
  importWith: ImportEnum;
  note: Scalars['String'];
  patternFilename: Scalars['String'];
  photo: Scalars['Boolean'];
  productAlf?: Maybe<Scalars['Boolean']>;
  referer: Scalars['String'];
  refererIt: Scalars['String'];
  restockAt?: Maybe<Scalars['String']>;
  softwareHouse?: Maybe<PartnerSoftwareHouse>;
  suppliePsw: Scalars['String'];
  supplier: Scalars['Float'];
  supplierUser: Scalars['String'];
  telephone: Scalars['String'];
  telephoneIt: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
  vendorRule?: Maybe<Scalars['Float']>;
};

export type PartnerDetailModelEdge = {
  __typename?: 'PartnerDetailModelEdge';
  cursor: Scalars['String'];
  node: PartnerDetail;
};

export type PartnerDetailModelQueryBuilderAggregateModel = {
  __typename?: 'PartnerDetailModelQueryBuilderAggregateModel';
  count: Scalars['Int'];
};

export type PartnerDetailModelQueryBuilderPageInfoModel = {
  __typename?: 'PartnerDetailModelQueryBuilderPageInfoModel';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PartnerModelEdge = {
  __typename?: 'PartnerModelEdge';
  cursor: Scalars['String'];
  node: Partner;
};

export type PartnerModelQueryBuilderAggregateModel = {
  __typename?: 'PartnerModelQueryBuilderAggregateModel';
  count: Scalars['Int'];
};

export type PartnerModelQueryBuilderPageInfoModel = {
  __typename?: 'PartnerModelQueryBuilderPageInfoModel';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PartnerOrderPrice = {
  __typename?: 'PartnerOrderPrice';
  extraDiscount: Scalars['Float'];
  extraDiscountView: Scalars['String'];
  price: Scalars['Float'];
  priceView: Scalars['String'];
  priceWithExtraDiscount: Scalars['Float'];
  priceWithExtraDiscountView: Scalars['String'];
};

export type PartnerOrderPriceInput = {
  cSel: Scalars['String'];
  fullPrice: Scalars['Float'];
  productComponentId: Scalars['Float'];
  productId: Scalars['Float'];
  season: Scalars['String'];
};

export type PartnerSoftwareHouse = {
  __typename?: 'PartnerSoftwareHouse';
  baseTable: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  namespace?: Maybe<Scalars['String']>;
  placeOrder?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type PartnerSoftwareHouseModelEdge = {
  __typename?: 'PartnerSoftwareHouseModelEdge';
  cursor: Scalars['String'];
  node: PartnerSoftwareHouse;
};

export type PartnerSoftwareHouseModelQueryBuilderAggregateModel = {
  __typename?: 'PartnerSoftwareHouseModelQueryBuilderAggregateModel';
  count: Scalars['Int'];
};

export type PartnerSoftwareHouseModelQueryBuilderPageInfoModel = {
  __typename?: 'PartnerSoftwareHouseModelQueryBuilderPageInfoModel';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PassResetViewDispatchOptions = {
  __typename?: 'PassResetViewDispatchOptions';
  customerId: Scalars['Int'];
  languageId: Scalars['Int'];
  meta: DispatchResultMeta;
  token: Scalars['String'];
};

export type PassResetViewDispatchResultModel = {
  __typename?: 'PassResetViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  passResetViewOptions: PassResetViewDispatchOptions;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  cost: PaymentMethodCost;
  countries: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isLocalMethod: Scalars['Boolean'];
  provider: Scalars['String'];
  source: Array<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  threshold: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  userCredit: Scalars['Boolean'];
};

export type PaymentMethodCost = {
  __typename?: 'PaymentMethodCost';
  currencyCode: Scalars['String'];
  value: Scalars['Float'];
};

export type PriceInfo = {
  __typename?: 'PriceInfo';
  hasDiscount: Scalars['Boolean'];
  hasGeoPricing: Scalars['Boolean'];
  hasTax: Scalars['Boolean'];
};

export type PriceInformationData = {
  __typename?: 'PriceInformationData';
  byDefault: PriceInformationDataObject;
  inCurrency: PriceInformationDataObject;
};

export type PriceInformationDataObject = {
  __typename?: 'PriceInformationDataObject';
  code: Scalars['String'];
  price: PriceInformationDataPrice;
};

export type PriceInformationDataPrice = {
  __typename?: 'PriceInformationDataPrice';
  value: Scalars['Float'];
  view: Scalars['String'];
};

export type ProductCatalogSuggestion = {
  __typename?: 'ProductCatalogSuggestion';
  message: Scalars['String'];
  type: Scalars['String'];
};

export type ProductCatalogView = {
  __typename?: 'ProductCatalogView';
  brand: ProductCatalogViewBrand;
  cSel: Scalars['String'];
  campaignInfo?: Maybe<ProductCatalogViewCampaignInfo>;
  catalogId: Scalars['ID'];
  category: ProductCatalogViewCategory;
  code: Scalars['String'];
  colorVariantComponentId: Scalars['Float'];
  colors: Array<ProductCatalogViewColor>;
  composition?: Maybe<Scalars['String']>;
  currencyCode: Scalars['String'];
  designerCode: Scalars['String'];
  designerColorCode?: Maybe<Scalars['String']>;
  discount: Scalars['Float'];
  exchangePriceWithDiscount?: Maybe<ExchangePriceWithDiscount>;
  hint?: Maybe<Scalars['Float']>;
  hintIcon?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  inOutlet: Scalars['Boolean'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  isWs?: Maybe<Scalars['Boolean']>;
  locale: Scalars['String'];
  measure?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<GuiProductColorVariantMedia>>>;
  metadata: ProductCatalogViewMetadata;
  newSeason?: Maybe<Scalars['Boolean']>;
  partnerPrices: ProductViewPartnerPrice;
  price: ProductCatalogViewPrice;
  priceView: ProductCatalogViewPrice;
  productId: Scalars['ID'];
  quantity: Scalars['Float'];
  season?: Maybe<Scalars['String']>;
  sectionDetails?: Maybe<Array<Maybe<ProductSectionDetail>>>;
  showStartFromLabel?: Maybe<Scalars['Boolean']>;
  sizeGuide?: Maybe<SizeGuide>;
  sizes: Array<ProductCatalogViewSize>;
  storeId: Scalars['String'];
  suggestions?: Maybe<Array<Maybe<ProductCatalogSuggestion>>>;
  url: Scalars['String'];
};


export type ProductCatalogViewMediaArgs = {
  data: CatalogGetGuiProductColorVariantMediaInput;
};

export type ProductCatalogViewBrand = {
  __typename?: 'ProductCatalogViewBrand';
  id: Scalars['ID'];
  label: Scalars['String'];
  url: Scalars['String'];
};

export type ProductCatalogViewCampaignInfo = {
  __typename?: 'ProductCatalogViewCampaignInfo';
  banner?: Maybe<ProductCatalogViewCampaignInfoBanner>;
  catalogCouponInfo?: Maybe<Scalars['String']>;
  singlePageCouponInfo?: Maybe<Scalars['String']>;
  singlePageDiscountInfo?: Maybe<Scalars['String']>;
};

export type ProductCatalogViewCampaignInfoBanner = {
  __typename?: 'ProductCatalogViewCampaignInfoBanner';
  labels: Array<Scalars['String']>;
  url: Scalars['String'];
};

export type ProductCatalogViewCategory = {
  __typename?: 'ProductCatalogViewCategory';
  category: ProductCatalogViewCategoryData;
  mainParentCategory: ProductCatalogViewCategoryData;
  parentCategory: ProductCatalogViewCategoryData;
};

export type ProductCatalogViewCategoryData = {
  __typename?: 'ProductCatalogViewCategoryData';
  id: Scalars['ID'];
  label: Scalars['String'];
  url: Scalars['String'];
};

export type ProductCatalogViewColor = {
  __typename?: 'ProductCatalogViewColor';
  available: Scalars['Boolean'];
  code: Scalars['String'];
  groupId?: Maybe<Scalars['ID']>;
  label: Scalars['String'];
  select: Scalars['String'];
  url: Scalars['String'];
  variantComponentId?: Maybe<Scalars['Float']>;
};

export type ProductCatalogViewMetadata = {
  __typename?: 'ProductCatalogViewMetadata';
  description?: Maybe<Scalars['String']>;
  editorsNote?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ProductCatalogViewPrice = {
  __typename?: 'ProductCatalogViewPrice';
  price: ProductComponentPriceDataValuesVal;
  withDiscount: ProductComponentPriceDataValuesVal;
};

export type ProductCatalogViewSize = {
  __typename?: 'ProductCatalogViewSize';
  available: Scalars['Boolean'];
  campaignIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  couponDiscount?: Maybe<Scalars['Float']>;
  couponInfo?: Maybe<Scalars['String']>;
  currencyCode: Scalars['String'];
  discount: Scalars['Float'];
  exchangePriceWithDiscount?: Maybe<ExchangePriceWithDiscount>;
  hint?: Maybe<Scalars['Float']>;
  hintIcon?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  order?: Maybe<Scalars['Float']>;
  price: ProductCatalogViewPrice;
  priceView: ProductCatalogViewPrice;
  productComponentId: Scalars['Float'];
  quantity: Scalars['Float'];
  sSel: Scalars['String'];
  variantComponentId?: Maybe<Scalars['Float']>;
};

export type ProductCatalogViewV2 = {
  __typename?: 'ProductCatalogViewV2';
  brand: Scalars['String'];
  cSel: Scalars['String'];
  campaignInfo?: Maybe<Scalars['String']>;
  catalogId: Scalars['ID'];
  categories: Array<Scalars['String']>;
  color: Scalars['String'];
  discount: Scalars['Int'];
  finalPrice: MoneyValueTransformer;
  hint: Scalars['Int'];
  hintIcon: Scalars['String'];
  id: Scalars['ID'];
  images?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  newSeason?: Maybe<Scalars['Boolean']>;
  originalPrice: MoneyValueTransformer;
  outlet?: Maybe<Scalars['Boolean']>;
  productId: Scalars['ID'];
  quantities: Scalars['Int'];
  season: Scalars['String'];
  sizes: Array<ProductCatalogViewV2Size>;
  sku: Scalars['String'];
  url: Scalars['String'];
};

export type ProductCatalogViewV2Size = {
  __typename?: 'ProductCatalogViewV2Size';
  available: Scalars['Boolean'];
  name: Scalars['String'];
  partnerIds?: Maybe<Array<Scalars['ID']>>;
};

export type ProductComponentPriceDataValuesVal = {
  __typename?: 'ProductComponentPriceDataValuesVal';
  tax: Scalars['String'];
  taxIncluded: Scalars['String'];
  taxable: Scalars['String'];
};

export type ProductComponentView = {
  __typename?: 'ProductComponentView';
  activeCampaigns: Array<Scalars['Float']>;
  brand: ProductCatalogViewBrand;
  cSel: Scalars['String'];
  catalogId: Scalars['ID'];
  categoryTree: ProductCatalogViewCategory;
  code: Scalars['String'];
  colorLabel?: Maybe<Scalars['String']>;
  composition: Scalars['String'];
  designerCode: Scalars['String'];
  designerColorCode: Scalars['String'];
  discount: Scalars['Float'];
  enabled?: Maybe<Scalars['Boolean']>;
  fGiglioCode: Scalars['String'];
  haveCoupon: Scalars['Boolean'];
  hint: Scalars['Float'];
  hintIcon: Scalars['String'];
  id: Scalars['ID'];
  images?: Maybe<Array<Scalars['String']>>;
  isWs?: Maybe<Scalars['Boolean']>;
  locale: Scalars['String'];
  measure: Scalars['String'];
  media?: Maybe<Array<Maybe<GuiProductColorVariantMedia>>>;
  metadata: ProductCatalogViewMetadata;
  originalPrice: MoneyValueTransformer;
  price: MoneyValueTransformer;
  priceInfo: PriceInfo;
  priceWithDiscount: MoneyValueTransformer;
  productComponentEnabled: Scalars['Boolean'];
  productId: Scalars['ID'];
  quantity: Scalars['Float'];
  sSel: Scalars['String'];
  season: Scalars['String'];
  size: ProductComponentViewSize;
  sku: Scalars['String'];
  stylistColor: Scalars['String'];
  suppliedBy?: Maybe<Array<Maybe<SuppliedBy>>>;
  url: Scalars['String'];
};

export type ProductComponentViewSize = {
  __typename?: 'ProductComponentViewSize';
  label: Scalars['String'];
  sortBy?: Maybe<Scalars['Float']>;
};

export type ProductPermanent = {
  __typename?: 'ProductPermanent';
  cSel: Scalars['String'];
  currentPage: Scalars['Float'];
  lastPage: Scalars['Float'];
  newSeason: Scalars['String'];
  partner?: Maybe<Partner>;
  partnerId: Scalars['Float'];
  productData?: Maybe<ProductPermanentData>;
  productId: Scalars['Float'];
};

export type ProductPermanentApiResponse = {
  __typename?: 'ProductPermanentApiResponse';
  currentPage: Scalars['Float'];
  nextPage?: Maybe<Scalars['String']>;
  productPermanents?: Maybe<Array<Maybe<ProductPermanent>>>;
};

export type ProductPermanentData = {
  __typename?: 'ProductPermanentData';
  brand: Scalars['String'];
  category: Scalars['String'];
  color: Scalars['String'];
  department: Scalars['String'];
  gender: Scalars['String'];
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  season: Scalars['String'];
  sku: Scalars['String'];
};

export type ProductResponse = {
  __typename?: 'ProductResponse';
  brandId: Scalars['Float'];
  cSel: Scalars['String'];
  categoryId: Scalars['Float'];
  colorId: Scalars['Float'];
  discounts: Array<DiscountResponseModel>;
  giglioCode: Scalars['String'];
  id: Scalars['String'];
  media?: Maybe<Array<Maybe<GuiProductColorVariantMedia>>>;
  parentCategoryId: Scalars['Float'];
  productData?: Maybe<ProductCatalogView>;
  productId: Scalars['Float'];
  sku: Scalars['String'];
};


export type ProductResponseMediaArgs = {
  data: CatalogGetGuiProductColorVariantMediaInput;
};


export type ProductResponseProductDataArgs = {
  data?: InputMaybe<ProductSingleViewResolverInput>;
};

export type ProductSectionDetail = {
  __typename?: 'ProductSectionDetail';
  handle: Scalars['String'];
  taxonomies?: Maybe<Array<Maybe<SectionDetailChildren>>>;
  title: Scalars['String'];
};

export type ProductSingleViewByBarcodeInput = {
  barcode: Scalars['String'];
  locale: Scalars['String'];
};

export type ProductSingleViewInput = {
  locale: Scalars['String'];
  partnerFilterMode?: InputMaybe<Scalars['String']>;
  productData?: InputMaybe<Array<InputMaybe<CatalogProductData>>>;
  refreshCache?: InputMaybe<Scalars['Boolean']>;
  withCache?: InputMaybe<Scalars['Boolean']>;
};

export type ProductSingleViewResolverInput = {
  locale: Scalars['String'];
  partnerFilterMode?: InputMaybe<Scalars['String']>;
  refreshCache?: InputMaybe<Scalars['Boolean']>;
  withCache?: InputMaybe<Scalars['Boolean']>;
};

export type ProductToTransfer = {
  __typename?: 'ProductToTransfer';
  cSel: Scalars['String'];
  currentSeason: Scalars['String'];
  fGiglioCode: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  partners?: Maybe<Array<Maybe<ProductToTransferPartner>>>;
  productData?: Maybe<ProductToTransferData>;
  productId: Scalars['Int'];
  sku: Scalars['String'];
};

export type ProductToTransferData = {
  __typename?: 'ProductToTransferData';
  brand?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
};

export type ProductToTransferPartner = {
  __typename?: 'ProductToTransferPartner';
  partner?: Maybe<Partner>;
  partnerId: Scalars['Int'];
  season: Scalars['String'];
};

export type ProductViewCurrentUrlInput = {
  entityId: Scalars['Int'];
  entityType: Scalars['String'];
};

export type ProductViewDispatchOptions = {
  __typename?: 'ProductViewDispatchOptions';
  cSel?: Maybe<Scalars['String']>;
  meta: DispatchResultMeta;
  productId: Scalars['Float'];
};

export type ProductViewDispatchResult = {
  __typename?: 'ProductViewDispatchResult';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  productViewOptions?: Maybe<ProductViewDispatchOptions>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
};

export type ProductViewFacet = {
  __typename?: 'ProductViewFacet';
  columns?: Maybe<Scalars['Int']>;
  defaultExpanded: Scalars['Boolean'];
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  presentation: FacetPresentation;
  values: Array<FacetValue>;
};

export type ProductViewPagination = {
  __typename?: 'ProductViewPagination';
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  nextCursor: Scalars['String'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  prevCursor: Scalars['String'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type ProductViewPartnerPrice = {
  __typename?: 'ProductViewPartnerPrice';
  cSel: Scalars['String'];
  components: Array<ProductViewPartnerPricesComponent>;
  discount: Scalars['Float'];
  discountedPrice: Scalars['Float'];
  discountedPriceView: Scalars['String'];
  fullprice: Scalars['Float'];
  fullpriceView: Scalars['String'];
};

export type ProductViewPartnerPricesComponent = {
  __typename?: 'ProductViewPartnerPricesComponent';
  discount: Scalars['Float'];
  discountedPrice: Scalars['Float'];
  discountedPriceView: Scalars['String'];
  fullprice: Scalars['Float'];
  fullpriceView: Scalars['String'];
  productComponentId: Scalars['Float'];
};

export type ProductsDiscountByDiscountRange = {
  __typename?: 'ProductsDiscountByDiscountRange';
  count: Scalars['Float'];
  filter?: Maybe<Filter>;
  pageInfo: PageInfo;
  productsDiscountGroup: Array<ProductsDiscountGroup>;
};

export type ProductsDiscountGroup = {
  __typename?: 'ProductsDiscountGroup';
  id: Scalars['String'];
  productSingleView?: Maybe<ProductCatalogView>;
  products: Array<ProductResponse>;
};


export type ProductsDiscountGroupProductSingleViewArgs = {
  data: ProductSingleViewResolverInput;
};

export type ProductsToTransferAggregations = {
  __typename?: 'ProductsToTransferAggregations';
  categories?: Maybe<Array<Maybe<TransferCategoryFacet>>>;
  lines?: Maybe<Array<Maybe<TransferLineFacet>>>;
  partners?: Maybe<Array<Maybe<TransferPartnerFacet>>>;
};

export type ProductsToTransferPagination = {
  __typename?: 'ProductsToTransferPagination';
  hasNextPage: Scalars['Boolean'];
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  catalogProductView: CatalogProductView;
  contactConnection: ContactConnectionResponse;
  customer: Customer;
  dispatchUrl: DispatchUrl;
  getDiscountRanges: Array<DiscountRange>;
  getDiscountsSuggested: Array<DiscountSuggested>;
  getEligiblePermanent?: Maybe<ProductPermanentApiResponse>;
  getPartner: Partner;
  getPartners: Array<Partner>;
  getPermanent?: Maybe<ProductPermanentApiResponse>;
  getProductsDiscountByDiscountRange: ProductsDiscountByDiscountRange;
  order: Order;
  partnerConnection: PartnerConnectionResponse;
  partnerOrderPrice: PartnerOrderPrice;
  productSingleView: Array<ProductCatalogView>;
  productSingleViewByBarcode: ProductCatalogView;
  productsToTransfer?: Maybe<GetProductsToTransferResponse>;
  search: SearchResult;
  seasons: SeasonConnectionResponse;
};


export type QueryCatalogProductViewArgs = {
  data: GetCatalogProductViewInput;
};


export type QueryContactConnectionArgs = {
  data: ConnectionRequestInput;
};


export type QueryDispatchUrlArgs = {
  data: DispatchUrlInput;
};


export type QueryGetDiscountRangesArgs = {
  data: GetDiscountRangesRequestInput;
};


export type QueryGetEligiblePermanentArgs = {
  data: GetEligibleProductPermanentInput;
};


export type QueryGetPartnerArgs = {
  data: GetPartnerByIdRequestInput;
};


export type QueryGetPermanentArgs = {
  data: GetEligibleProductPermanentInput;
};


export type QueryGetProductsDiscountByDiscountRangeArgs = {
  data: GetProductsDiscountByDiscountRangeRequestInput;
};


export type QueryOrderArgs = {
  data: GetOrderRequestInput;
};


export type QueryPartnerConnectionArgs = {
  data: ConnectionRequestInput;
};


export type QueryPartnerOrderPriceArgs = {
  data: PartnerOrderPriceInput;
};


export type QueryProductSingleViewArgs = {
  data: ProductSingleViewInput;
};


export type QueryProductSingleViewByBarcodeArgs = {
  data: ProductSingleViewByBarcodeInput;
};


export type QueryProductsToTransferArgs = {
  data: GetProductsToTransferInput;
};


export type QuerySearchArgs = {
  data: SearchRequestInput;
};


export type QuerySeasonsArgs = {
  data: ConnectionRequestInput;
};

export type QueryBuilderDataModel = {
  children?: InputMaybe<Array<QueryBuilderDataModel>>;
  condition?: InputMaybe<Scalars['String']>;
  metaKey: Scalars['String'];
  metaValue: Scalars['String'];
  operator: Scalars['String'];
};

export type QueryBuilderPaginationModel = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
  orderBy?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
};

export type QueryFilterInput = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  discountValue?: InputMaybe<Scalars['Float']>;
  freeField?: InputMaybe<Scalars['String']>;
  parentCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  permanent?: InputMaybe<Scalars['Boolean']>;
  seasons?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RefundMethod = {
  __typename?: 'RefundMethod';
  id: Scalars['Float'];
  key: Scalars['String'];
  value: Scalars['String'];
};

export type ReturnInfo = {
  __typename?: 'ReturnInfo';
  itemReturnReasons?: Maybe<Array<ItemReturnReason>>;
  refundMethods?: Maybe<Array<RefundMethod>>;
  returnMethods?: Maybe<Array<ReturnMethod>>;
};

export type ReturnMethod = {
  __typename?: 'ReturnMethod';
  id: Scalars['String'];
  key: Scalars['String'];
  price: MoneyValueTransformer;
  value: Scalars['String'];
};

export type ReturnPolicy = {
  __typename?: 'ReturnPolicy';
  allowed: Scalars['Boolean'];
  bankTransferRefund: Scalars['Boolean'];
  blockReturnMessage?: Maybe<Scalars['String']>;
  daysLeft: Scalars['Float'];
  lastReturnDate: Scalars['String'];
};

export type Rma = {
  __typename?: 'Rma';
  checkInAt?: Maybe<Scalars['DateTime']>;
  closedAt?: Maybe<Scalars['DateTime']>;
  code: Scalars['String'];
  components: Array<RmaOrderComponent>;
  createdAt: Scalars['DateTime'];
  deliveredAt?: Maybe<Scalars['DateTime']>;
  emailSentAt?: Maybe<Scalars['DateTime']>;
  generalStatus: Scalars['String'];
  id: Scalars['ID'];
  order: Order;
  orderId: Scalars['Float'];
  payment: RmaPayment;
  processedAt?: Maybe<Scalars['DateTime']>;
  refundAt?: Maybe<Scalars['DateTime']>;
  shipmentMethodId: Scalars['String'];
  shippedAt?: Maybe<Scalars['DateTime']>;
  shippingAddress: RmaShippingAddress;
  tracking?: Maybe<RmaTracking>;
  updatedAt: Scalars['DateTime'];
};

export type RmaOrderComponent = {
  __typename?: 'RmaOrderComponent';
  id: Scalars['Float'];
  price: Scalars['Float'];
  quantity: Scalars['Float'];
  reasonId: Scalars['String'];
  rechargeable: Scalars['Boolean'];
  status: Scalars['String'];
};

export type RmaPayment = {
  __typename?: 'RmaPayment';
  info?: Maybe<Array<RmaPaymentInfo>>;
  methodId: Scalars['Float'];
  refundedAmount?: Maybe<Scalars['Float']>;
};

export type RmaPaymentInfo = {
  __typename?: 'RmaPaymentInfo';
  description: Scalars['String'];
  name: Scalars['String'];
};

export type RmaShippingAddress = {
  __typename?: 'RmaShippingAddress';
  addressLines: Array<Scalars['String']>;
  at: Scalars['String'];
  city: Scalars['String'];
  countryId: Scalars['String'];
  mobile: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  region: Scalars['String'];
  surname: Scalars['String'];
  zipCode: Scalars['String'];
};

export type RmaShippingAddressInput = {
  addressLines: Array<Scalars['String']>;
  at?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  countryId: Scalars['String'];
  mobile: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  region?: InputMaybe<Scalars['String']>;
  surname: Scalars['String'];
  zipCode: Scalars['String'];
};

export type RmaTracking = {
  __typename?: 'RmaTracking';
  courierName: Scalars['String'];
  trackingNumber: Scalars['String'];
};

export type RmaTrackingInput = {
  courierName: Scalars['String'];
  trackingNumber: Scalars['String'];
};

export type RmaView = {
  __typename?: 'RmaView';
  checkInAt?: Maybe<RmaViewDate>;
  closedAt?: Maybe<RmaViewDate>;
  code: Scalars['String'];
  components: Array<RmaViewComponent>;
  createdAt: RmaViewDate;
  deliveredAt?: Maybe<RmaViewDate>;
  emailSentAt?: Maybe<RmaViewDate>;
  generalStatus: Scalars['String'];
  id: Scalars['ID'];
  locale: Scalars['String'];
  orderId: Scalars['Float'];
  paymentInfo?: Maybe<Array<RmaPaymentInfo>>;
  paymentMethod: RmaViewPaymentMethod;
  processedAt?: Maybe<RmaViewDate>;
  refundAt?: Maybe<RmaViewDate>;
  refundedAmount: MoneyValueTransformer;
  shipmentMethod: RmaViewShipmentMethod;
  shippedAt?: Maybe<RmaViewDate>;
  shippingAddress: RmaViewShippingAddress;
  tracking?: Maybe<RmaTracking>;
  updatedAt: RmaViewDate;
};

export type RmaViewComponent = {
  __typename?: 'RmaViewComponent';
  id: Scalars['Float'];
  locale: Scalars['String'];
  price: MoneyValueTransformer;
  product: ProductComponentView;
  quantity: Scalars['Float'];
  reason: RmaViewStrapiPhrase;
  rechargeable: Scalars['Boolean'];
  status: Scalars['String'];
};

export type RmaViewCountry = {
  __typename?: 'RmaViewCountry';
  code: Scalars['Float'];
  id: Scalars['Float'];
  iso2: Scalars['String'];
  iso3: Scalars['String'];
  name: Scalars['String'];
};

export type RmaViewDate = {
  __typename?: 'RmaViewDate';
  date?: Maybe<Scalars['DateTime']>;
  view: Scalars['String'];
};

export type RmaViewPaymentMethod = {
  __typename?: 'RmaViewPaymentMethod';
  cost: MoneyValueTransformer;
  id: Scalars['Float'];
  provider: Scalars['String'];
};

export type RmaViewShipmentMethod = {
  __typename?: 'RmaViewShipmentMethod';
  id: Scalars['String'];
  price: MoneyValueTransformer;
  title: Scalars['String'];
};

export type RmaViewShippingAddress = {
  __typename?: 'RmaViewShippingAddress';
  addressLines: Array<Scalars['String']>;
  at: Scalars['String'];
  city: Scalars['String'];
  country: RmaViewCountry;
  mobile: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  region: Scalars['String'];
  surname: Scalars['String'];
  zipCode: Scalars['String'];
};

export type RmaViewStrapiPhrase = {
  __typename?: 'RmaViewStrapiPhrase';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type ScaleSize = {
  __typename?: 'ScaleSize';
  data: Array<SizeGroupsSizeGroupsData>;
  isDefault: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type SearchGendered = {
  __typename?: 'SearchGendered';
  designers?: Maybe<Array<Maybe<SuggestedDesigner>>>;
  products?: Maybe<Array<Maybe<SuggestedProduct>>>;
  suggestions?: Maybe<Array<Maybe<Suggestion>>>;
};

export type SearchRequestInput = {
  locale: Scalars['String'];
  mainParentId: Scalars['ID'];
  profileId: Scalars['String'];
  searchInput: Scalars['String'];
};

export type SearchResult = {
  __typename?: 'SearchResult';
  kid?: Maybe<SearchGendered>;
  lifestyle?: Maybe<SearchGendered>;
  man?: Maybe<SearchGendered>;
  showMore?: Maybe<ShowMore>;
  woman?: Maybe<SearchGendered>;
};

export type Season = {
  __typename?: 'Season';
  description: Scalars['String'];
  id: Scalars['ID'];
  isCurrent: Scalars['Boolean'];
  isNext: Scalars['Boolean'];
  sequence: Scalars['Int'];
  showOutOfStock: Scalars['Boolean'];
};

export type SeasonConnectionResponse = {
  __typename?: 'SeasonConnectionResponse';
  aggregate?: Maybe<SeasonModelQueryBuilderAggregateModel>;
  edges?: Maybe<Array<SeasonModelEdge>>;
  pageInfo?: Maybe<SeasonModelQueryBuilderPageInfoModel>;
};

export type SeasonModelEdge = {
  __typename?: 'SeasonModelEdge';
  cursor: Scalars['String'];
  node: Season;
};

export type SeasonModelQueryBuilderAggregateModel = {
  __typename?: 'SeasonModelQueryBuilderAggregateModel';
  count: Scalars['Int'];
};

export type SeasonModelQueryBuilderPageInfoModel = {
  __typename?: 'SeasonModelQueryBuilderPageInfoModel';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type SectionDetailChildren = {
  __typename?: 'SectionDetailChildren';
  name: Scalars['String'];
  terms: Array<Scalars['String']>;
};

export type SetPermanentResponse = {
  __typename?: 'SetPermanentResponse';
  message: Scalars['String'];
  status: Scalars['Float'];
};

export type SetProductPermanentDataInput = {
  cSel: Scalars['String'];
  partnerId: Scalars['Float'];
  productId: Scalars['Float'];
};

export type SetProductPermanentInput = {
  data: Array<SetProductPermanentDataInput>;
};

export type ShipmentMethod = {
  __typename?: 'ShipmentMethod';
  available: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  data: Array<ShipmentMethodData>;
  deletedAt?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  hasFreeShipping: Scalars['Boolean'];
  id: Scalars['ID'];
  isExpress: Scalars['Boolean'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type ShipmentMethodData = {
  __typename?: 'ShipmentMethodData';
  currencyCode: Scalars['String'];
  iso3: Array<Scalars['String']>;
  price: Scalars['Float'];
  priceInformation: PriceInformationData;
  threshold: Scalars['Float'];
};

export type ShippingAddress = {
  __typename?: 'ShippingAddress';
  address: Scalars['String'];
  city: Scalars['String'];
  contact: Scalars['String'];
  contactNumber: Scalars['String'];
  country: Scalars['String'];
  countryId: Scalars['String'];
  id: Scalars['ID'];
  maxShippingHour?: Maybe<Scalars['Float']>;
  zip: Scalars['String'];
};

export type ShowMore = {
  __typename?: 'ShowMore';
  label: Scalars['String'];
  url: Scalars['String'];
};

export type SizeGroupsSizeGroupsData = {
  __typename?: 'SizeGroupsSizeGroupsData';
  row?: Maybe<Scalars['Float']>;
  values?: Maybe<Array<Scalars['String']>>;
};

export type SizeGuide = {
  __typename?: 'SizeGuide';
  name: Scalars['String'];
  scaleSizes?: Maybe<Array<Maybe<ScaleSize>>>;
};

export type SuggestedDesigner = {
  __typename?: 'SuggestedDesigner';
  documentIds: Array<Scalars['String']>;
  label: Scalars['String'];
  url: Scalars['String'];
};

export type SuggestedProduct = {
  __typename?: 'SuggestedProduct';
  documentIds: Array<Scalars['String']>;
  imageUrl: Scalars['String'];
  label: Scalars['String'];
  url: Scalars['String'];
};

export type Suggestion = {
  __typename?: 'Suggestion';
  documentIds: Array<Scalars['String']>;
  label: Scalars['String'];
  url: Scalars['String'];
};

export type SuppliedBy = {
  __typename?: 'SuppliedBy';
  facilityId: Scalars['String'];
  partnerId: Scalars['Float'];
  position: Scalars['Float'];
  quantity: Scalars['Float'];
};

export type SyncProductsTransferInput = {
  items: Array<SyncProductsTransferItemInput>;
};

export type SyncProductsTransferItemInput = {
  cSel: Scalars['String'];
  productId: Scalars['Int'];
  season: Scalars['String'];
};

export type SyncProductsTransferResponse = {
  __typename?: 'SyncProductsTransferResponse';
  failed: Scalars['Int'];
  message: Scalars['String'];
  processed: Scalars['Int'];
  skipped: Scalars['Int'];
  succeeded: Scalars['Int'];
  success: Scalars['Boolean'];
};

export type TransferCategoryFacet = {
  __typename?: 'TransferCategoryFacet';
  id: Scalars['Int'];
  label: Scalars['String'];
};

export type TransferLineFacet = {
  __typename?: 'TransferLineFacet';
  id: Scalars['Int'];
  label: Scalars['String'];
};

export type TransferPartnerFacet = {
  __typename?: 'TransferPartnerFacet';
  id: Scalars['Int'];
  label: Scalars['String'];
};

export type UpdatePreferenceViewDispatchOptions = {
  __typename?: 'UpdatePreferenceViewDispatchOptions';
  meta: DispatchResultMeta;
  trackEmailId?: Maybe<Scalars['Float']>;
};

export type UpdatePreferenceViewDispatchResultModel = {
  __typename?: 'UpdatePreferenceViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  updatePreferenceViewOptions: UpdatePreferenceViewDispatchOptions;
  vector: Scalars['String'];
};

export type UpdateProductDiscountRequestInput = {
  discountRangeId: Scalars['String'];
  discountValue: Scalars['Float'];
  id: Scalars['String'];
};

export type UpdateProductsDiscountByFilterRequestInput = {
  discountRangeId: Scalars['String'];
  discountValue: Scalars['Float'];
  queryFilter: QueryFilterInput;
};

export type UpdateProductsDiscountMultipleRequestInput = {
  discountRangeId: Scalars['String'];
  discountValue: Scalars['Float'];
  productId: Scalars['Float'];
};

export type UrlEntity = {
  __typename?: 'UrlEntity';
  id: Scalars['Int'];
  type: Scalars['String'];
};

export type WishlistShareDispatchOptions = {
  __typename?: 'WishlistShareDispatchOptions';
  meta: DispatchResultMeta;
  token: Scalars['String'];
};

export type WishlistShareViewDispatchResultModel = {
  __typename?: 'WishlistShareViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
  wishlistShareViewOptions: WishlistShareDispatchOptions;
};

export type WishlistViewDispatchOptions = {
  __typename?: 'WishlistViewDispatchOptions';
  meta: DispatchResultMeta;
};

export type WishlistViewDispatchResultModel = {
  __typename?: 'WishlistViewDispatchResultModel';
  alternatives?: Maybe<Array<DispatchResultAlternativeModel>>;
  currentPathname?: Maybe<Scalars['String']>;
  identifier?: Maybe<DispatchResultIdentifier>;
  languageCode: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  redirectInfo?: Maybe<DispatchResultRedirectInfoModel>;
  statusCode: Scalars['Int'];
  type: Scalars['String'];
  vector: Scalars['String'];
  wishlistViewOptions: WishlistViewDispatchOptions;
};

export type GetCatalogFilteredQueryVariables = Exact<{
  data: GetCatalogProductViewInput;
}>;


export type GetCatalogFilteredQuery = { __typename?: 'Query', catalogProductView: { __typename?: 'CatalogProductView', facets?: Array<{ __typename?: 'ProductViewFacet', id: string, label?: string | null, columns?: number | null, presentation: FacetPresentation, values: Array<{ __typename?: 'FacetValue', isSelected: boolean, value: string, enabled: boolean, href?: string | null, label?: string | null }> } | null> | null, pagination: { __typename?: 'ProductViewPagination', page: number, pageSize: number, totalPages: number, totalItems: number, hasNextPage: boolean, hasPrevPage: boolean }, productCatalogViews?: Array<{ __typename?: 'ProductCatalogViewV2', hintIcon: string, cSel: string, campaignInfo?: string | null, brand: string, catalogId: string, categories: Array<string>, color: string, discount: number, hint: number, images?: Array<string> | null, name: string, productId: string, quantities: number, sku: string, url: string, id: string, season: string, sizes: Array<{ __typename?: 'ProductCatalogViewV2Size', name: string, available: boolean, partnerIds?: Array<string> | null }>, originalPrice: { __typename?: 'MoneyValueTransformer', currencyCode: string, values: { __typename?: 'MoneyValueInt', tax: number, taxIncluded: number, taxable: number }, view: { __typename?: 'MoneyValueString', tax: string, taxIncluded: string, taxable: string } }, finalPrice: { __typename?: 'MoneyValueTransformer', currencyCode: string, values: { __typename?: 'MoneyValueInt', tax: number, taxIncluded: number, taxable: number }, view: { __typename?: 'MoneyValueString', tax: string, taxIncluded: string, taxable: string } } } | null> | null, sorts: Array<{ __typename?: 'CatalogProductViewSort', isActive: boolean, field: CatalogSortV2, label: string }>, activeFacets?: Array<{ __typename?: 'CatalogProductViewActiveFacet', id: string, label: string, value: string } | null> | null } };

export type GetProductDetailsOldQueryVariables = Exact<{
  data: ProductSingleViewInput;
}>;


export type GetProductDetailsOldQuery = { __typename?: 'Query', productSingleView: Array<{ __typename?: 'ProductCatalogView', designerCode: string, code: string, showStartFromLabel?: boolean | null, storeId: string, productId: string, hint?: number | null, hintIcon?: string | null, cSel: string, images?: Array<string | null> | null, inOutlet: boolean, newSeason?: boolean | null, season?: string | null, quantity: number, discount: number, metadata: { __typename?: 'ProductCatalogViewMetadata', title: string }, colors: Array<{ __typename?: 'ProductCatalogViewColor', available: boolean, code: string, label: string, select: string, variantComponentId?: number | null, groupId?: string | null, url: string }>, exchangePriceWithDiscount?: { __typename?: 'ExchangePriceWithDiscount', view: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string }, values: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string } } | null, campaignInfo?: { __typename?: 'ProductCatalogViewCampaignInfo', catalogCouponInfo?: string | null, singlePageCouponInfo?: string | null, singlePageDiscountInfo?: string | null } | null, category: { __typename?: 'ProductCatalogViewCategory', category: { __typename?: 'ProductCatalogViewCategoryData', id: string, label: string, url: string }, mainParentCategory: { __typename?: 'ProductCatalogViewCategoryData', id: string, label: string, url: string }, parentCategory: { __typename?: 'ProductCatalogViewCategoryData', id: string, label: string, url: string } }, media?: Array<{ __typename?: 'GuiProductColorVariantMedia', name?: string | null, url: string } | null> | null, brand: { __typename?: 'ProductCatalogViewBrand', url: string, label: string }, priceView: { __typename?: 'ProductCatalogViewPrice', price: { __typename?: 'ProductComponentPriceDataValuesVal', taxIncluded: string }, withDiscount: { __typename?: 'ProductComponentPriceDataValuesVal', taxIncluded: string } }, price: { __typename?: 'ProductCatalogViewPrice', price: { __typename?: 'ProductComponentPriceDataValuesVal', taxIncluded: string }, withDiscount: { __typename?: 'ProductComponentPriceDataValuesVal', taxIncluded: string } }, sizes: Array<{ __typename?: 'ProductCatalogViewSize', couponInfo?: string | null, couponDiscount?: number | null, available: boolean, campaignIds?: Array<string | null> | null, label: string, order?: number | null, quantity: number, productComponentId: number, sSel: string, discount: number, hint?: number | null, hintIcon?: string | null, priceView: { __typename?: 'ProductCatalogViewPrice', price: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string }, withDiscount: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string } }, price: { __typename?: 'ProductCatalogViewPrice', price: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string }, withDiscount: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string } } }>, sizeGuide?: { __typename?: 'SizeGuide', name: string, scaleSizes?: Array<{ __typename?: 'ScaleSize', isDefault: boolean, label?: string | null, name: string, data: Array<{ __typename?: 'SizeGroupsSizeGroupsData', row?: number | null, values?: Array<string> | null }> } | null> | null } | null }> };

export type GetProductDetailsQueryVariables = Exact<{
  data: ProductSingleViewInput;
}>;


export type GetProductDetailsQuery = { __typename?: 'Query', productSingleView: Array<{ __typename?: 'ProductCatalogView', designerCode: string, code: string, showStartFromLabel?: boolean | null, storeId: string, productId: string, hint?: number | null, hintIcon?: string | null, cSel: string, images?: Array<string | null> | null, inOutlet: boolean, newSeason?: boolean | null, season?: string | null, quantity: number, discount: number, partnerPrices: { __typename?: 'ProductViewPartnerPrice', cSel: string, discountedPriceView: string, discountedPrice: number, fullprice: number, fullpriceView: string, discount: number, components: Array<{ __typename?: 'ProductViewPartnerPricesComponent', productComponentId: number, discountedPriceView: string, discountedPrice: number, fullprice: number, fullpriceView: string, discount: number }> }, metadata: { __typename?: 'ProductCatalogViewMetadata', title: string }, colors: Array<{ __typename?: 'ProductCatalogViewColor', available: boolean, code: string, label: string, select: string, variantComponentId?: number | null, groupId?: string | null, url: string }>, exchangePriceWithDiscount?: { __typename?: 'ExchangePriceWithDiscount', view: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string }, values: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string } } | null, campaignInfo?: { __typename?: 'ProductCatalogViewCampaignInfo', catalogCouponInfo?: string | null, singlePageCouponInfo?: string | null, singlePageDiscountInfo?: string | null } | null, category: { __typename?: 'ProductCatalogViewCategory', category: { __typename?: 'ProductCatalogViewCategoryData', id: string, label: string, url: string }, mainParentCategory: { __typename?: 'ProductCatalogViewCategoryData', id: string, label: string, url: string }, parentCategory: { __typename?: 'ProductCatalogViewCategoryData', id: string, label: string, url: string } }, media?: Array<{ __typename?: 'GuiProductColorVariantMedia', name?: string | null, url: string } | null> | null, brand: { __typename?: 'ProductCatalogViewBrand', url: string, label: string }, priceView: { __typename?: 'ProductCatalogViewPrice', price: { __typename?: 'ProductComponentPriceDataValuesVal', taxIncluded: string }, withDiscount: { __typename?: 'ProductComponentPriceDataValuesVal', taxIncluded: string } }, price: { __typename?: 'ProductCatalogViewPrice', price: { __typename?: 'ProductComponentPriceDataValuesVal', taxIncluded: string }, withDiscount: { __typename?: 'ProductComponentPriceDataValuesVal', taxIncluded: string } }, sizes: Array<{ __typename?: 'ProductCatalogViewSize', couponInfo?: string | null, couponDiscount?: number | null, available: boolean, campaignIds?: Array<string | null> | null, label: string, order?: number | null, quantity: number, productComponentId: number, sSel: string, discount: number, hint?: number | null, hintIcon?: string | null, priceView: { __typename?: 'ProductCatalogViewPrice', price: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string }, withDiscount: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string } }, price: { __typename?: 'ProductCatalogViewPrice', price: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string }, withDiscount: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string } } }>, sizeGuide?: { __typename?: 'SizeGuide', name: string, scaleSizes?: Array<{ __typename?: 'ScaleSize', isDefault: boolean, label?: string | null, name: string, data: Array<{ __typename?: 'SizeGroupsSizeGroupsData', row?: number | null, values?: Array<string> | null }> } | null> | null } | null }> };

export type SearchSuggestionQueryVariables = Exact<{
  data: SearchRequestInput;
}>;


export type SearchSuggestionQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', kid?: { __typename?: 'SearchGendered', suggestions?: Array<{ __typename?: 'Suggestion', label: string, url: string } | null> | null, designers?: Array<{ __typename?: 'SuggestedDesigner', label: string, url: string } | null> | null } | null, man?: { __typename?: 'SearchGendered', suggestions?: Array<{ __typename?: 'Suggestion', label: string, url: string } | null> | null, designers?: Array<{ __typename?: 'SuggestedDesigner', label: string, url: string } | null> | null } | null, woman?: { __typename?: 'SearchGendered', suggestions?: Array<{ __typename?: 'Suggestion', label: string, url: string } | null> | null, designers?: Array<{ __typename?: 'SuggestedDesigner', label: string, url: string } | null> | null } | null, lifestyle?: { __typename?: 'SearchGendered', suggestions?: Array<{ __typename?: 'Suggestion', label: string, url: string } | null> | null, designers?: Array<{ __typename?: 'SuggestedDesigner', label: string, url: string } | null> | null } | null, showMore?: { __typename?: 'ShowMore', label: string, url: string } | null } };

export type DispatchUrlQueryVariables = Exact<{
  data: DispatchUrlInput;
}>;


export type DispatchUrlQuery = { __typename?: 'Query', dispatchUrl: { __typename?: 'AccountViewDispatchResultModel' } | { __typename?: 'CartViewDispatchResultModel' } | { __typename?: 'CatalogViewDispatchResult', type: string, catalogViewOptions: { __typename?: 'CatalogViewDispatchOptions', catalogV2?: { __typename?: 'CatalogV2ViewOptions', query?: string | null, facets?: Array<{ __typename?: 'CatalogV2Facet', id: string, values?: Array<string> | null }> | null } | null, catalog?: { __typename?: 'CatalogViewOptions', baseQuery?: Array<{ __typename?: 'CatalogBaseQuery', in?: Array<{ __typename?: 'CatalogBaseQueryData', type: string, values: Array<string> } | null> | null }> | null, facets?: { __typename?: 'CatalogFacet', brandIds?: Array<string> | null, categoryIds?: Array<string> | null, colorGroupIds?: Array<string> | null, manClothingSizeGroupIds?: Array<string> | null, manShoesSizeGroupIds?: Array<string> | null, sizeIds?: Array<string> | null, womanClothingSizeGroupIds?: Array<string> | null, womanShoesSizeGroupIds?: Array<string> | null } | null } | null } } | { __typename?: 'ContactsViewDispatchResultModel' } | { __typename?: 'DesignersViewDispatchResultModel' } | { __typename?: 'FestiveSeasonViewDispatchResultModel' } | { __typename?: 'HomeViewDispatchResultModel' } | { __typename?: 'InvestorSiteViewDispatchResultModel' } | { __typename?: 'LandingBeautySeekersViewDispatchResultModel' } | { __typename?: 'LandingGiftGuide24ViewDispatchResultModel' } | { __typename?: 'LandingGiftGuideViewDispatchResultModel' } | { __typename?: 'LandingHomeDecorViewDispatchResultModel' } | { __typename?: 'LandingSpecial0ViewDispatchResultModel' } | { __typename?: 'LandingSpecial1ViewDispatchResultModel' } | { __typename?: 'LandingVestiaireCollectiveViewDispatchResultModel' } | { __typename?: 'LifestyleViewDispatchResult' } | { __typename?: 'NotificationViewDispatchResultModel' } | { __typename?: 'OrderViewDispatchResult' } | { __typename?: 'PageDispatchResultModel' } | { __typename?: 'PassResetViewDispatchResultModel' } | { __typename?: 'ProductViewDispatchResult', type: string, productViewOptions?: { __typename?: 'ProductViewDispatchOptions', productId: number } | null } | { __typename?: 'UpdatePreferenceViewDispatchResultModel' } | { __typename?: 'WishlistShareViewDispatchResultModel' } | { __typename?: 'WishlistViewDispatchResultModel' } };

export type ProductByBarcodeQueryVariables = Exact<{
  data: ProductSingleViewByBarcodeInput;
}>;


export type ProductByBarcodeQuery = { __typename?: 'Query', productSingleViewByBarcode: { __typename?: 'ProductCatalogView', designerCode: string, code: string, showStartFromLabel?: boolean | null, storeId: string, productId: string, hint?: number | null, hintIcon?: string | null, cSel: string, images?: Array<string | null> | null, inOutlet: boolean, newSeason?: boolean | null, quantity: number, discount: number, metadata: { __typename?: 'ProductCatalogViewMetadata', title: string }, colors: Array<{ __typename?: 'ProductCatalogViewColor', available: boolean, code: string, label: string, select: string, variantComponentId?: number | null, groupId?: string | null, url: string }>, exchangePriceWithDiscount?: { __typename?: 'ExchangePriceWithDiscount', view: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string }, values: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string } } | null, campaignInfo?: { __typename?: 'ProductCatalogViewCampaignInfo', catalogCouponInfo?: string | null, singlePageCouponInfo?: string | null, singlePageDiscountInfo?: string | null } | null, category: { __typename?: 'ProductCatalogViewCategory', category: { __typename?: 'ProductCatalogViewCategoryData', id: string, label: string, url: string }, mainParentCategory: { __typename?: 'ProductCatalogViewCategoryData', id: string, label: string, url: string }, parentCategory: { __typename?: 'ProductCatalogViewCategoryData', id: string, label: string, url: string } }, media?: Array<{ __typename?: 'GuiProductColorVariantMedia', name?: string | null, url: string } | null> | null, brand: { __typename?: 'ProductCatalogViewBrand', url: string, label: string }, priceView: { __typename?: 'ProductCatalogViewPrice', price: { __typename?: 'ProductComponentPriceDataValuesVal', taxIncluded: string }, withDiscount: { __typename?: 'ProductComponentPriceDataValuesVal', taxIncluded: string } }, price: { __typename?: 'ProductCatalogViewPrice', price: { __typename?: 'ProductComponentPriceDataValuesVal', taxIncluded: string }, withDiscount: { __typename?: 'ProductComponentPriceDataValuesVal', taxIncluded: string } }, sizes: Array<{ __typename?: 'ProductCatalogViewSize', couponInfo?: string | null, couponDiscount?: number | null, available: boolean, campaignIds?: Array<string | null> | null, label: string, order?: number | null, quantity: number, productComponentId: number, sSel: string, discount: number, hint?: number | null, hintIcon?: string | null, priceView: { __typename?: 'ProductCatalogViewPrice', price: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string }, withDiscount: { __typename?: 'ProductComponentPriceDataValuesVal', tax: string, taxIncluded: string, taxable: string } } }>, sizeGuide?: { __typename?: 'SizeGuide', name: string, scaleSizes?: Array<{ __typename?: 'ScaleSize', isDefault: boolean, label?: string | null, name: string, data: Array<{ __typename?: 'SizeGroupsSizeGroupsData', row?: number | null, values?: Array<string> | null }> } | null> | null } | null } };

export type GetCustomerQueryVariables = Exact<{
  data: GetCustomerOrderViewInput;
}>;


export type GetCustomerQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, name?: string | null, email: string, surname?: string | null, billingAddress?: string | null, shippingAddresses?: Array<{ __typename?: 'CustomerShippingAddressExtended', id: string, address: Array<string>, at?: string | null, city: string, country: string, mobile?: string | null, name: string, surname: string, phone?: string | null, verified: boolean, zipCode: string, isEnabled: boolean, isPreferred?: boolean | null, region?: string | null, deletedAt?: any | null }> | null, ordersViewPage?: { __typename?: 'OrderViewPage', total: number } | null, ordersView?: Array<{ __typename?: 'OrderView', id: string, status: string, referenceNumber: string, date: any, tax: string, total: string, billingAddress: { __typename?: 'OrderViewCustomerBillingAddress', name: string, maskedName: string, surname: string, maskedSurname: string, address: string, city: string, country: string, zipCode: string }, rma?: Array<{ __typename?: 'RmaView', tracking?: { __typename?: 'RmaTracking', courierName: string, trackingNumber: string } | null }> | null, shipment?: { __typename?: 'OrderViewShipment', courierName: string, trackingNumber: string } | null, shipmentMethod?: { __typename?: 'ShipmentMethod', id: string } | null, shippingAddress: { __typename?: 'OrderViewCustomerShippingAddress', name: string, maskedName: string, surname: string, maskedSurname: string, at?: string | null, city: string, zipCode: string, country: string, countryId: number, region?: string | null, mobile: string, phone?: string | null, address: Array<string> }, components?: Array<{ __typename?: 'OrderViewComponent', id: string, quantity: number, product: { __typename?: 'ProductComponentView', id: string, sku: string, code: string, colorLabel?: string | null, designerCode: string, fGiglioCode: string, images?: Array<string> | null, productId: string, size: { __typename?: 'ProductComponentViewSize', label: string }, brand: { __typename?: 'ProductCatalogViewBrand', id: string, label: string, url: string }, categoryTree: { __typename?: 'ProductCatalogViewCategory', category: { __typename?: 'ProductCatalogViewCategoryData', id: string, label: string, url: string } }, metadata: { __typename?: 'ProductCatalogViewMetadata', description?: string | null, title: string, editorsNote?: string | null }, priceWithDiscount: { __typename?: 'MoneyValueTransformer', currencyCode: string, values: { __typename?: 'MoneyValueInt', tax: number, taxIncluded: number, taxable: number } } } }> | null, fullStatus?: Array<{ __typename?: 'OrderViewFullStatusStep', key: string, label: string, active: boolean }> | null }> | null } };

export type CreateOrderMutationVariables = Exact<{
  data: CreatePwaOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createPwaOrder: { __typename?: 'Order', id: string } };

export type CreateRmaMutationVariables = Exact<{
  data: CreateRmaInput;
}>;


export type CreateRmaMutation = { __typename?: 'Mutation', createRma: { __typename?: 'Rma', id: string } };

export type CancelOrderMutationVariables = Exact<{
  data: CancelOrderInput;
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', cancelOrder: string };

export type GetOrderDetailsQueryVariables = Exact<{
  data: GetOrderRequestInput;
}>;


export type GetOrderDetailsQuery = { __typename?: 'Query', order: { __typename?: 'Order', id: string, customerShipmentId: number, customerSatisfaction: number, date: string, dutyAdd: number, ipAddress: string, isGift: boolean, referenceNumber: string, paymentId: string, semaphore: string, shippingCost: number, status: string, subTotal: number, tax: number, total: number, locale: string, vector: string, components: Array<{ __typename?: 'OrderComponent', id: string, quantity: number, price: number, tax: number, pricePurchase: number, extraDiscount: number, taxes: Array<{ __typename?: 'OrderComponentTax', id: string, currencyCode: string, name: string, quantity: number, type: string, value: number }> }> } };

export type GetPartnerOrderPriceQueryVariables = Exact<{
  data: PartnerOrderPriceInput;
}>;


export type GetPartnerOrderPriceQuery = { __typename?: 'Query', partnerOrderPrice: { __typename?: 'PartnerOrderPrice', price: number, extraDiscount: number, priceWithExtraDiscount: number, priceView: string, extraDiscountView: string, priceWithExtraDiscountView: string } };

export type ContactListQueryVariables = Exact<{
  data: ConnectionRequestInput;
}>;


export type ContactListQuery = { __typename?: 'Query', contactConnection: { __typename?: 'ContactConnectionResponse', aggregate?: { __typename?: 'ContactModelQueryBuilderAggregateModel', count: number } | null, edges?: Array<{ __typename?: 'ContactModelEdge', node: { __typename?: 'Contact', name: string, country: string, region: string, city: string, shippingAddress?: Array<{ __typename?: 'ShippingAddress', contact: string, contactNumber: string }> | null } }> | null } };

export type GetDiscountRangesQueryVariables = Exact<{
  data: GetDiscountRangesRequestInput;
}>;


export type GetDiscountRangesQuery = { __typename?: 'Query', getDiscountRanges: Array<{ __typename?: 'DiscountRange', id: string, discountRangeType: string, discount: number, description: string, maxDiscount: number, allowedDiscount?: Array<number | null> | null, dateChoiceEnd: string }> };

export type GetDiscountsSuggestedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDiscountsSuggestedQuery = { __typename?: 'Query', getDiscountsSuggested: Array<{ __typename?: 'DiscountSuggested', id: string, discountRangeId: string, brandId: number, mainCategoryId: number, discount: number }> };

export type UseLastSeasonDiscountMutationVariables = Exact<{
  data: CopyDiscountsFromCheckboxInput;
}>;


export type UseLastSeasonDiscountMutation = { __typename?: 'Mutation', copyDiscountsFromCheckbox: { __typename?: 'CopyDiscountsFromCheckboxResponse', success: boolean, modifiedCount: number } };

export type DetailFragment = { __typename?: 'PartnerDetail', importWith: ImportEnum, softwareHouse?: { __typename?: 'PartnerSoftwareHouse', description: string } | null };

export type ContactFragment = { __typename?: 'Contact', name: string, country: string, region: string, city: string, shippingAddress?: Array<{ __typename?: 'ShippingAddress', contact: string, contactNumber: string }> | null };

export type GetPartnerListQueryVariables = Exact<{
  data: ConnectionRequestInput;
}>;


export type GetPartnerListQuery = { __typename?: 'Query', partnerConnection: { __typename?: 'PartnerConnectionResponse', aggregate?: { __typename?: 'PartnerModelQueryBuilderAggregateModel', count: number } | null, edges?: Array<{ __typename?: 'PartnerModelEdge', node: { __typename?: 'Partner', id: string, personId?: string | null, desc?: string | null, disabled: boolean, pos: number, contact?: { __typename?: 'Contact', name: string, country: string, region: string, city: string, shippingAddress?: Array<{ __typename?: 'ShippingAddress', contact: string, contactNumber: string }> | null } | null, detail?: { __typename?: 'PartnerDetail', importWith: ImportEnum, softwareHouse?: { __typename?: 'PartnerSoftwareHouse', description: string } | null } | null } }> | null } };

export type GetParnersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetParnersQuery = { __typename?: 'Query', getPartners: Array<{ __typename?: 'Partner', desc?: string | null, name: string, id: string }> };

export type GetPartnerDetailsQueryVariables = Exact<{
  data: GetPartnerByIdRequestInput;
}>;


export type GetPartnerDetailsQuery = { __typename?: 'Query', getPartner: { __typename?: 'Partner', id: string, desc?: string | null, partnerCategoryId?: number | null, name: string, formatId: number, emailNotify: string, controller?: string | null, discA: number, discB: number, discC: number, discS: number, pos: number, usePos: boolean, slug?: string | null, personId?: string | null, facilityId?: string | null, vRuleSp: boolean, hasWarehouse: boolean, barcodeType?: BarcodeEnum | null, enablePrinter: boolean, disabled: boolean, ordersFee?: number | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, contact?: { __typename?: 'Contact', name: string, country: string, region: string, city: string, shippingAddress?: Array<{ __typename?: 'ShippingAddress', contact: string, contactNumber: string }> | null } | null, detail?: { __typename?: 'PartnerDetail', importWith: ImportEnum, softwareHouse?: { __typename?: 'PartnerSoftwareHouse', description: string } | null } | null } };

export type GetProductsToTransferQueryVariables = Exact<{
  data: GetProductsToTransferInput;
}>;


export type GetProductsToTransferQuery = { __typename?: 'Query', productsToTransfer?: { __typename?: 'GetProductsToTransferResponse', pagination: { __typename?: 'ProductsToTransferPagination', total: number, skip: number, limit: number, hasNextPage: boolean }, aggregations: { __typename?: 'ProductsToTransferAggregations', categories?: Array<{ __typename?: 'TransferCategoryFacet', id: number, label: string } | null> | null, lines?: Array<{ __typename?: 'TransferLineFacet', id: number, label: string } | null> | null, partners?: Array<{ __typename?: 'TransferPartnerFacet', id: number, label: string } | null> | null }, products?: Array<{ __typename?: 'ProductToTransfer', productId: number, cSel: string, fGiglioCode: string, sku: string, image?: string | null, currentSeason: string, productData?: { __typename?: 'ProductToTransferData', color?: string | null, brand?: string | null, category?: string | null } | null, partners?: Array<{ __typename?: 'ProductToTransferPartner', partnerId: number, season: string, partner?: { __typename?: 'Partner', id: string, name: string } | null } | null> | null } | null> | null } | null };

export type GetAllSeasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSeasonsQuery = { __typename?: 'Query', seasons: { __typename?: 'SeasonConnectionResponse', edges?: Array<{ __typename?: 'SeasonModelEdge', node: { __typename?: 'Season', id: string, description: string } }> | null } };

export type SyncProductsTransferMutationVariables = Exact<{
  data: SyncProductsTransferInput;
}>;


export type SyncProductsTransferMutation = { __typename?: 'Mutation', syncProductsTransfer?: { __typename?: 'SyncProductsTransferResponse', message: string, processed: number, success: boolean, succeeded: number, failed: number, skipped: number } | null };

export type GetProductsDiscountByDiscountRangeQueryVariables = Exact<{
  data: GetProductsDiscountByDiscountRangeRequestInput;
}>;


export type GetProductsDiscountByDiscountRangeQuery = { __typename?: 'Query', getProductsDiscountByDiscountRange: { __typename?: 'ProductsDiscountByDiscountRange', count: number, filter?: { __typename?: 'Filter', discounts?: Array<number | null> | null, seasons?: Array<string | null> | null, categories?: Array<{ __typename?: 'Category', id: number, label: string } | null> | null, brands?: Array<{ __typename?: 'Brand', id: number, label: string } | null> | null } | null, productsDiscountGroup: Array<{ __typename?: 'ProductsDiscountGroup', productSingleView?: { __typename?: 'ProductCatalogView', productId: string, code: string, cSel: string, season?: string | null, images?: Array<string | null> | null, price: { __typename?: 'ProductCatalogViewPrice', price: { __typename?: 'ProductComponentPriceDataValuesVal', taxIncluded: string } }, brand: { __typename?: 'ProductCatalogViewBrand', id: string, label: string }, category: { __typename?: 'ProductCatalogViewCategory', category: { __typename?: 'ProductCatalogViewCategoryData', id: string, label: string }, parentCategory: { __typename?: 'ProductCatalogViewCategoryData', id: string, label: string }, mainParentCategory: { __typename?: 'ProductCatalogViewCategoryData', id: string, label: string } } } | null, products: Array<{ __typename?: 'ProductResponse', cSel: string, id: string, sku: string, productData?: { __typename?: 'ProductCatalogView', images?: Array<string | null> | null, designerColorCode?: string | null, sizes: Array<{ __typename?: 'ProductCatalogViewSize', label: string, quantity: number }>, colors: Array<{ __typename?: 'ProductCatalogViewColor', select: string, label: string }> } | null, media?: Array<{ __typename?: 'GuiProductColorVariantMedia', url: string } | null> | null, discounts: Array<{ __typename?: 'DiscountResponseModel', discountValue: number, discountRangeId: string, permanent: boolean }> }> }> } };

export type GetEligiblePermanentQueryVariables = Exact<{
  data: GetEligibleProductPermanentInput;
}>;


export type GetEligiblePermanentQuery = { __typename?: 'Query', getEligiblePermanent?: { __typename?: 'ProductPermanentApiResponse', currentPage: number, nextPage?: string | null, productPermanents?: Array<{ __typename?: 'ProductPermanent', productId: number, cSel: string, newSeason: string, partnerId: number, partner?: { __typename?: 'Partner', id: string, name: string } | null, productData?: { __typename?: 'ProductPermanentData', sku: string, season: string, brand: string, category: string, department: string, gender: string, images?: Array<string | null> | null, color: string } | null } | null> | null } | null };

export type GetPermanentQueryVariables = Exact<{
  data: GetEligibleProductPermanentInput;
}>;


export type GetPermanentQuery = { __typename?: 'Query', getPermanent?: { __typename?: 'ProductPermanentApiResponse', currentPage: number, nextPage?: string | null, productPermanents?: Array<{ __typename?: 'ProductPermanent', productId: number, cSel: string, newSeason: string, partnerId: number, partner?: { __typename?: 'Partner', id: string, name: string } | null, productData?: { __typename?: 'ProductPermanentData', sku: string, season: string, brand: string, category: string, department: string, gender: string, images?: Array<string | null> | null, color: string } | null } | null> | null } | null };

export type SetPermanentMutationVariables = Exact<{
  data: SetProductPermanentInput;
}>;


export type SetPermanentMutation = { __typename?: 'Mutation', setPermanent: { __typename?: 'SetPermanentResponse', message: string, status: number } };

export type UpdateProductDiscountMutationVariables = Exact<{
  data: UpdateProductDiscountRequestInput;
}>;


export type UpdateProductDiscountMutation = { __typename?: 'Mutation', updateProductDiscount: boolean };

export type UpdateProductsDiscountMultipleMutationVariables = Exact<{
  data: UpdateProductsDiscountMultipleRequestInput;
}>;


export type UpdateProductsDiscountMultipleMutation = { __typename?: 'Mutation', updateProductsDiscountMultiple: boolean };

export type UpdateProductsDiscountByFilterMutationVariables = Exact<{
  data: UpdateProductsDiscountByFilterRequestInput;
}>;


export type UpdateProductsDiscountByFilterMutation = { __typename?: 'Mutation', updateProductsDiscountByFilter: boolean };

export const DetailFragmentDoc = gql`
    fragment Detail on PartnerDetail {
  importWith
  softwareHouse {
    description
  }
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on Contact {
  name
  country
  region
  city
  shippingAddress {
    contact
    contactNumber
  }
}
    `;
export const GetCatalogFilteredDocument = gql`
    query GetCatalogFiltered($data: GetCatalogProductViewInput!) {
  catalogProductView(data: $data) {
    facets {
      id
      label
      columns
      presentation
      values {
        isSelected
        value
        enabled
        href
        label
      }
    }
    pagination {
      page
      pageSize
      totalPages
      totalItems
      hasNextPage
      hasPrevPage
    }
    productCatalogViews {
      hintIcon
      cSel
      campaignInfo
      brand
      catalogId
      categories
      color
      discount
      hint
      images
      name
      productId
      quantities
      sku
      url
      id
      season
      sizes {
        name
        available
        partnerIds
      }
      originalPrice {
        currencyCode
        values {
          tax
          taxIncluded
          taxable
        }
        view {
          tax
          taxIncluded
          taxable
        }
      }
      finalPrice {
        currencyCode
        values {
          tax
          taxIncluded
          taxable
        }
        view {
          tax
          taxIncluded
          taxable
        }
      }
    }
    sorts {
      isActive
      field
      label
    }
    activeFacets {
      id
      label
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCatalogFilteredGQL extends Apollo.Query<GetCatalogFilteredQuery, GetCatalogFilteredQueryVariables> {
    override document = GetCatalogFilteredDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProductDetailsOldDocument = gql`
    query getProductDetailsOld($data: ProductSingleViewInput!) {
  productSingleView(data: $data) {
    designerCode
    metadata {
      title
    }
    colors {
      available
      code
      label
      select
      variantComponentId
      groupId
      url
    }
    code
    showStartFromLabel
    exchangePriceWithDiscount {
      view {
        tax
        taxIncluded
        taxable
      }
      values {
        tax
        taxIncluded
        taxable
      }
    }
    campaignInfo {
      catalogCouponInfo
      singlePageCouponInfo
      singlePageDiscountInfo
    }
    storeId
    category {
      category {
        id
        label
        url
      }
      mainParentCategory {
        id
        label
        url
      }
      parentCategory {
        id
        label
        url
      }
    }
    productId
    hint
    hintIcon
    metadata {
      title
    }
    cSel
    images
    media(data: {transformations: ""}) {
      name
      url
    }
    brand {
      url
      label
    }
    inOutlet
    newSeason
    season
    quantity
    priceView {
      price {
        taxIncluded
      }
      withDiscount {
        taxIncluded
      }
    }
    price {
      price {
        taxIncluded
      }
      withDiscount {
        taxIncluded
      }
    }
    discount
    sizes {
      couponInfo
      couponDiscount
      available
      campaignIds
      label
      order
      quantity
      productComponentId
      sSel
      discount
      hint
      hintIcon
      priceView {
        price {
          tax
          taxIncluded
          taxable
        }
        withDiscount {
          tax
          taxIncluded
          taxable
        }
      }
      price {
        price {
          tax
          taxIncluded
          taxable
        }
        withDiscount {
          tax
          taxIncluded
          taxable
        }
      }
    }
    sizeGuide {
      name
      scaleSizes {
        data {
          row
          values
        }
        isDefault
        label
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProductDetailsOldGQL extends Apollo.Query<GetProductDetailsOldQuery, GetProductDetailsOldQueryVariables> {
    override document = GetProductDetailsOldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProductDetailsDocument = gql`
    query getProductDetails($data: ProductSingleViewInput!) {
  productSingleView(data: $data) {
    partnerPrices {
      cSel
      discountedPriceView
      discountedPrice
      fullprice
      fullpriceView
      discount
      components {
        productComponentId
        discountedPriceView
        discountedPrice
        fullprice
        fullpriceView
        discount
      }
    }
    designerCode
    metadata {
      title
    }
    colors {
      available
      code
      label
      select
      variantComponentId
      groupId
      url
    }
    code
    showStartFromLabel
    exchangePriceWithDiscount {
      view {
        tax
        taxIncluded
        taxable
      }
      values {
        tax
        taxIncluded
        taxable
      }
    }
    campaignInfo {
      catalogCouponInfo
      singlePageCouponInfo
      singlePageDiscountInfo
    }
    storeId
    category {
      category {
        id
        label
        url
      }
      mainParentCategory {
        id
        label
        url
      }
      parentCategory {
        id
        label
        url
      }
    }
    productId
    hint
    hintIcon
    metadata {
      title
    }
    cSel
    images
    media(data: {transformations: ""}) {
      name
      url
    }
    brand {
      url
      label
    }
    inOutlet
    newSeason
    season
    quantity
    priceView {
      price {
        taxIncluded
      }
      withDiscount {
        taxIncluded
      }
    }
    price {
      price {
        taxIncluded
      }
      withDiscount {
        taxIncluded
      }
    }
    discount
    sizes {
      couponInfo
      couponDiscount
      available
      campaignIds
      label
      order
      quantity
      productComponentId
      sSel
      discount
      hint
      hintIcon
      priceView {
        price {
          tax
          taxIncluded
          taxable
        }
        withDiscount {
          tax
          taxIncluded
          taxable
        }
      }
      price {
        price {
          tax
          taxIncluded
          taxable
        }
        withDiscount {
          tax
          taxIncluded
          taxable
        }
      }
    }
    sizeGuide {
      name
      scaleSizes {
        data {
          row
          values
        }
        isDefault
        label
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProductDetailsGQL extends Apollo.Query<GetProductDetailsQuery, GetProductDetailsQueryVariables> {
    override document = GetProductDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchSuggestionDocument = gql`
    query searchSuggestion($data: SearchRequestInput!) {
  search(data: $data) {
    kid {
      suggestions {
        label
        url
      }
      designers {
        label
        url
      }
    }
    man {
      suggestions {
        label
        url
      }
      designers {
        label
        url
      }
    }
    woman {
      suggestions {
        label
        url
      }
      designers {
        label
        url
      }
    }
    lifestyle {
      suggestions {
        label
        url
      }
      designers {
        label
        url
      }
    }
    showMore {
      label
      url
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchSuggestionGQL extends Apollo.Query<SearchSuggestionQuery, SearchSuggestionQueryVariables> {
    override document = SearchSuggestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DispatchUrlDocument = gql`
    query dispatchUrl($data: DispatchUrlInput!) {
  dispatchUrl(data: $data) {
    ... on CatalogViewDispatchResult {
      type
      catalogViewOptions {
        catalogV2 {
          query
          facets {
            id
            values
          }
        }
        catalog {
          baseQuery {
            in {
              type
              values
            }
          }
          facets {
            brandIds
            categoryIds
            colorGroupIds
            manClothingSizeGroupIds
            manShoesSizeGroupIds
            sizeIds
            womanClothingSizeGroupIds
            womanShoesSizeGroupIds
          }
        }
      }
    }
    ... on ProductViewDispatchResult {
      type
      productViewOptions {
        productId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DispatchUrlGQL extends Apollo.Query<DispatchUrlQuery, DispatchUrlQueryVariables> {
    override document = DispatchUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductByBarcodeDocument = gql`
    query productByBarcode($data: ProductSingleViewByBarcodeInput!) {
  productSingleViewByBarcode(data: $data) {
    designerCode
    metadata {
      title
    }
    colors {
      available
      code
      label
      select
      variantComponentId
      groupId
      url
    }
    code
    showStartFromLabel
    exchangePriceWithDiscount {
      view {
        tax
        taxIncluded
        taxable
      }
      values {
        tax
        taxIncluded
        taxable
      }
    }
    campaignInfo {
      catalogCouponInfo
      singlePageCouponInfo
      singlePageDiscountInfo
    }
    storeId
    category {
      category {
        id
        label
        url
      }
      mainParentCategory {
        id
        label
        url
      }
      parentCategory {
        id
        label
        url
      }
    }
    productId
    hint
    hintIcon
    metadata {
      title
    }
    cSel
    images
    media(data: {transformations: ""}) {
      name
      url
    }
    brand {
      url
      label
    }
    inOutlet
    newSeason
    quantity
    priceView {
      price {
        taxIncluded
      }
      withDiscount {
        taxIncluded
      }
    }
    price {
      price {
        taxIncluded
      }
      withDiscount {
        taxIncluded
      }
    }
    discount
    sizes {
      couponInfo
      couponDiscount
      available
      campaignIds
      label
      order
      quantity
      productComponentId
      sSel
      discount
      hint
      hintIcon
      priceView {
        price {
          tax
          taxIncluded
          taxable
        }
        withDiscount {
          tax
          taxIncluded
          taxable
        }
      }
    }
    sizeGuide {
      name
      scaleSizes {
        data {
          row
          values
        }
        isDefault
        label
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductByBarcodeGQL extends Apollo.Query<ProductByBarcodeQuery, ProductByBarcodeQueryVariables> {
    override document = ProductByBarcodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerDocument = gql`
    query getCustomer($data: GetCustomerOrderViewInput!) {
  customer {
    id
    name
    email
    surname
    billingAddress
    shippingAddresses(data: {locale: "it-IT"}) {
      id
      address
      at
      city
      country
      mobile
      name
      surname
      phone
      verified
      zipCode
      isEnabled
      isPreferred
      region
      deletedAt
    }
    ordersViewPage(data: $data) {
      total
    }
    ordersView(data: $data) {
      id
      status
      referenceNumber
      billingAddress {
        name
        maskedName
        surname
        maskedSurname
        address
        city
        country
        zipCode
      }
      date
      rma {
        tracking {
          courierName
          trackingNumber
        }
      }
      shipment {
        courierName
        trackingNumber
      }
      shipmentMethod {
        id
      }
      shippingAddress {
        name
        maskedName
        surname
        maskedSurname
        at
        city
        zipCode
        country
        countryId
        region
        mobile
        phone
        address
      }
      components {
        id
        quantity
        product {
          id
          sku
          size {
            label
          }
          brand {
            id
            label
            url
          }
          categoryTree {
            category {
              id
              label
              url
            }
          }
          code
          colorLabel
          designerCode
          fGiglioCode
          images
          metadata {
            description
            title
            editorsNote
          }
          priceWithDiscount {
            currencyCode
            values {
              tax
              taxIncluded
              taxable
            }
          }
          productId
        }
      }
      shipment {
        courierName
        trackingNumber
      }
      tax
      total
      fullStatus {
        key
        label
        active
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCustomerGQL extends Apollo.Query<GetCustomerQuery, GetCustomerQueryVariables> {
    override document = GetCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrderDocument = gql`
    mutation createOrder($data: CreatePwaOrderInput!) {
  createPwaOrder(data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrderGQL extends Apollo.Mutation<CreateOrderMutation, CreateOrderMutationVariables> {
    override document = CreateOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRmaDocument = gql`
    mutation createRma($data: CreateRmaInput!) {
  createRma(data: $data) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRmaGQL extends Apollo.Mutation<CreateRmaMutation, CreateRmaMutationVariables> {
    override document = CreateRmaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelOrderDocument = gql`
    mutation cancelOrder($data: CancelOrderInput!) {
  cancelOrder(data: $data)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelOrderGQL extends Apollo.Mutation<CancelOrderMutation, CancelOrderMutationVariables> {
    override document = CancelOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrderDetailsDocument = gql`
    query getOrderDetails($data: GetOrderRequestInput!) {
  order(data: $data) {
    id
    customerShipmentId
    customerSatisfaction
    date
    dutyAdd
    ipAddress
    isGift
    referenceNumber
    paymentId
    semaphore
    shippingCost
    status
    subTotal
    tax
    total
    locale
    vector
    components {
      id
      quantity
      price
      tax
      pricePurchase
      extraDiscount
      taxes {
        id
        currencyCode
        name
        quantity
        type
        value
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrderDetailsGQL extends Apollo.Query<GetOrderDetailsQuery, GetOrderDetailsQueryVariables> {
    override document = GetOrderDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPartnerOrderPriceDocument = gql`
    query getPartnerOrderPrice($data: PartnerOrderPriceInput!) {
  partnerOrderPrice(data: $data) {
    price
    extraDiscount
    priceWithExtraDiscount
    priceView
    extraDiscountView
    priceWithExtraDiscountView
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPartnerOrderPriceGQL extends Apollo.Query<GetPartnerOrderPriceQuery, GetPartnerOrderPriceQueryVariables> {
    override document = GetPartnerOrderPriceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContactListDocument = gql`
    query ContactList($data: ConnectionRequestInput!) {
  contactConnection(data: $data) {
    aggregate {
      count
    }
    edges {
      node {
        ...Contact
      }
    }
  }
}
    ${ContactFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ContactListGQL extends Apollo.Query<ContactListQuery, ContactListQueryVariables> {
    override document = ContactListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDiscountRangesDocument = gql`
    query GetDiscountRanges($data: GetDiscountRangesRequestInput!) {
  getDiscountRanges(data: $data) {
    id
    discountRangeType
    discount
    description
    maxDiscount
    allowedDiscount
    dateChoiceEnd
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDiscountRangesGQL extends Apollo.Query<GetDiscountRangesQuery, GetDiscountRangesQueryVariables> {
    override document = GetDiscountRangesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDiscountsSuggestedDocument = gql`
    query GetDiscountsSuggested {
  getDiscountsSuggested {
    id
    discountRangeId
    brandId
    mainCategoryId
    discount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDiscountsSuggestedGQL extends Apollo.Query<GetDiscountsSuggestedQuery, GetDiscountsSuggestedQueryVariables> {
    override document = GetDiscountsSuggestedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UseLastSeasonDiscountDocument = gql`
    mutation useLastSeasonDiscount($data: CopyDiscountsFromCheckboxInput!) {
  copyDiscountsFromCheckbox(data: $data) {
    success
    modifiedCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UseLastSeasonDiscountGQL extends Apollo.Mutation<UseLastSeasonDiscountMutation, UseLastSeasonDiscountMutationVariables> {
    override document = UseLastSeasonDiscountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPartnerListDocument = gql`
    query GetPartnerList($data: ConnectionRequestInput!) {
  partnerConnection(data: $data) {
    aggregate {
      count
    }
    edges {
      node {
        id
        personId
        desc
        disabled
        pos
        contact {
          ...Contact
        }
        detail {
          ...Detail
        }
      }
    }
  }
}
    ${ContactFragmentDoc}
${DetailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPartnerListGQL extends Apollo.Query<GetPartnerListQuery, GetPartnerListQueryVariables> {
    override document = GetPartnerListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetParnersDocument = gql`
    query getParners {
  getPartners {
    desc
    name
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetParnersGQL extends Apollo.Query<GetParnersQuery, GetParnersQueryVariables> {
    override document = GetParnersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPartnerDetailsDocument = gql`
    query GetPartnerDetails($data: GetPartnerByIdRequestInput!) {
  getPartner(data: $data) {
    id
    desc
    partnerCategoryId
    name
    formatId
    emailNotify
    controller
    discA
    discB
    discC
    discS
    pos
    usePos
    slug
    personId
    facilityId
    vRuleSp
    hasWarehouse
    barcodeType
    enablePrinter
    disabled
    ordersFee
    createdAt
    updatedAt
    deletedAt
    contact {
      ...Contact
    }
    detail {
      ...Detail
    }
  }
}
    ${ContactFragmentDoc}
${DetailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPartnerDetailsGQL extends Apollo.Query<GetPartnerDetailsQuery, GetPartnerDetailsQueryVariables> {
    override document = GetPartnerDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProductsToTransferDocument = gql`
    query GetProductsToTransfer($data: GetProductsToTransferInput!) {
  productsToTransfer(data: $data) {
    pagination {
      total
      skip
      limit
      hasNextPage
    }
    aggregations {
      categories {
        id
        label
      }
      lines {
        id
        label
      }
      partners {
        id
        label
      }
    }
    products {
      productId
      cSel
      fGiglioCode
      sku
      image
      currentSeason
      productData {
        color
        brand
        category
      }
      partners {
        partnerId
        season
        partner {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProductsToTransferGQL extends Apollo.Query<GetProductsToTransferQuery, GetProductsToTransferQueryVariables> {
    override document = GetProductsToTransferDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllSeasonsDocument = gql`
    query getAllSeasons {
  seasons(data: {pagination: {limit: 100}}) {
    edges {
      node {
        id
        description
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllSeasonsGQL extends Apollo.Query<GetAllSeasonsQuery, GetAllSeasonsQueryVariables> {
    override document = GetAllSeasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SyncProductsTransferDocument = gql`
    mutation SyncProductsTransfer($data: SyncProductsTransferInput!) {
  syncProductsTransfer(data: $data) {
    message
    processed
    success
    succeeded
    failed
    skipped
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SyncProductsTransferGQL extends Apollo.Mutation<SyncProductsTransferMutation, SyncProductsTransferMutationVariables> {
    override document = SyncProductsTransferDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProductsDiscountByDiscountRangeDocument = gql`
    query GetProductsDiscountByDiscountRange($data: GetProductsDiscountByDiscountRangeRequestInput!) {
  getProductsDiscountByDiscountRange(data: $data) {
    filter {
      discounts
      categories {
        id
        label
      }
      brands {
        id
        label
      }
      seasons
    }
    count
    productsDiscountGroup {
      productSingleView(data: {locale: "it-IT", partnerFilterMode: "INCLUDE"}) {
        productId
        code
        cSel
        season
        price {
          price {
            taxIncluded
          }
        }
        brand {
          id
          label
        }
        category {
          category {
            id
            label
          }
          parentCategory {
            id
            label
          }
          mainParentCategory {
            id
            label
          }
        }
        images
      }
      products {
        cSel
        id
        sku
        productData {
          images
          sizes {
            label
            quantity
          }
          colors {
            select
            label
          }
          designerColorCode
        }
        media(data: {featured: true, transformations: "prodPage"}) {
          url
        }
        discounts {
          discountValue
          discountRangeId
          permanent
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProductsDiscountByDiscountRangeGQL extends Apollo.Query<GetProductsDiscountByDiscountRangeQuery, GetProductsDiscountByDiscountRangeQueryVariables> {
    override document = GetProductsDiscountByDiscountRangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEligiblePermanentDocument = gql`
    query GetEligiblePermanent($data: GetEligibleProductPermanentInput!) {
  getEligiblePermanent(data: $data) {
    currentPage
    nextPage
    productPermanents {
      productId
      cSel
      newSeason
      partner {
        id
        name
      }
      partnerId
      productData {
        sku
        season
        brand
        category
        department
        gender
        images
        color
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEligiblePermanentGQL extends Apollo.Query<GetEligiblePermanentQuery, GetEligiblePermanentQueryVariables> {
    override document = GetEligiblePermanentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPermanentDocument = gql`
    query GetPermanent($data: GetEligibleProductPermanentInput!) {
  getPermanent(data: $data) {
    currentPage
    nextPage
    productPermanents {
      productId
      cSel
      newSeason
      partner {
        id
        name
      }
      partnerId
      productData {
        sku
        season
        brand
        category
        department
        gender
        images
        color
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPermanentGQL extends Apollo.Query<GetPermanentQuery, GetPermanentQueryVariables> {
    override document = GetPermanentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetPermanentDocument = gql`
    mutation SetPermanent($data: SetProductPermanentInput!) {
  setPermanent(data: $data) {
    message
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetPermanentGQL extends Apollo.Mutation<SetPermanentMutation, SetPermanentMutationVariables> {
    override document = SetPermanentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProductDiscountDocument = gql`
    mutation UpdateProductDiscount($data: UpdateProductDiscountRequestInput!) {
  updateProductDiscount(data: $data)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProductDiscountGQL extends Apollo.Mutation<UpdateProductDiscountMutation, UpdateProductDiscountMutationVariables> {
    override document = UpdateProductDiscountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProductsDiscountMultipleDocument = gql`
    mutation UpdateProductsDiscountMultiple($data: UpdateProductsDiscountMultipleRequestInput!) {
  updateProductsDiscountMultiple(data: $data)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProductsDiscountMultipleGQL extends Apollo.Mutation<UpdateProductsDiscountMultipleMutation, UpdateProductsDiscountMultipleMutationVariables> {
    override document = UpdateProductsDiscountMultipleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProductsDiscountByFilterDocument = gql`
    mutation UpdateProductsDiscountByFilter($data: UpdateProductsDiscountByFilterRequestInput!) {
  updateProductsDiscountByFilter(data: $data)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProductsDiscountByFilterGQL extends Apollo.Mutation<UpdateProductsDiscountByFilterMutation, UpdateProductsDiscountByFilterMutationVariables> {
    override document = UpdateProductsDiscountByFilterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }